import React from "react";
import { Box, Button, InputBase, Modal, Typography, Input, IconButton, Tooltip,Checkbox, InputAdornment, TextField } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useDispatch, useSelector } from "react-redux";
import { updatesearchProduct } from "../../Redux/page";
import SearchIcon from '@mui/icons-material/Search';
import { ProductTable } from "../../sub_components/product_table";
import { useEffect, useState } from "react";
import { Editor } from "primereact/editor";
import AddIcon from '@mui/icons-material/Add';
import '../../App.css';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditIcon from '@mui/icons-material/Edit';
import SettingsIcon from '@mui/icons-material/Settings';
import CloseIcon from '@mui/icons-material/Close';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { updateEdit, updateModal, updateProductDetail, updateProducts, addScannedProduct, removeScannedProduct, updateScannedProduct, clearScannedProducts } from "../../Redux/products";
import { updateCategoryDetails } from "../../Redux/category-redux";
import { Toast } from 'primereact/toast';
import { useRef } from "react";
import * as Yup from "yup";
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import CustomAxios from "../../utils/CustomAxios";
import { OrderModal, OrderModalDelivery, useGetInventory, useGetProducts } from "../globalFunctions";
import { updateUpdatedDate } from "../../Redux/orders";
import CircularProgress from '@mui/material/CircularProgress';
import { useGetCategories, useGetSubCategories } from "../globalFunctions";
import dayjs from "dayjs";
import { LocalizationProvider, MobileTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Autocomplete, Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import DownloadIcon from '@mui/icons-material/Download';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import * as XLSX from "xlsx";
import BarcodeScanner from "../BarcodeScanner";
import VisionProductScanner from "../VisionProductScanner";



export function ProductDetails() {
    const dispatch = useDispatch()
    const toast = useRef(null);
    const authToken = localStorage.getItem('authtoken')
    const modal = useSelector(state => state.products.modal)
    const productDetails = useSelector(state => state.products.productdetail)
    const inventory = useSelector(state => state.inventory.inventory);
    const edit = useSelector(state => state.products.edit)
    const actcategory = useSelector(state => state.category.category)
    const [category, setCategory] = useState([])
    const [subCategory, setSubCategory] = useState([])
    const sub_category = useSelector(state => state.subcategory.subcategory)
    const getSubCategory = useGetSubCategories();
    const getCategory = useGetCategories()
    const getInventory = useGetInventory()
    const [imagePreviews, setImagePreviews] = useState([]);
    const [loading, setLoading] = useState(false)
    const [errors, setErrors] = useState({});
    const categoryModal = useSelector(state => state.category.modal);
    const categoryEdit = useSelector(state => state.category.categoryEdit);
    const categoryDetails = useSelector(state => state.category.categoryDetails);
    const [formData, setFormData] = useState({
        inventory: [],
        capacitydetails: {}, 
        images: [],
        addons: [],
    });
    const getProducts = useGetProducts()
    const selectedHub = useSelector(state => state.user.selected_hub)?.[0]; // gets ID
    const [filteredInventory, setFilteredInventory] = useState([]);
    const user_role = localStorage.getItem('role');
    const [bulkDialogOpen, setBulkDialogOpen] = useState(false);
    const [bulkUploading, setBulkUploading] = useState(false);
    const [bulkErrors, setBulkErrors] = useState([]);
    const bulkFileInputRef = useRef(null);
    const [scanDialogOpen, setScanDialogOpen] = useState(false);
    const [scannedCode, setScannedCode] = useState("");
    const [scanError, setScanError] = useState("");
    const [scanPermissionLoading, setScanPermissionLoading] = useState(false);
    const [scanLookupLoading, setScanLookupLoading] = useState(false);
    const [barcodeImageUrl, setBarcodeImageUrl] = useState("");
    const [barcodeGenerating, setBarcodeGenerating] = useState(false);
    // Vision AI states
    const [scanMode, setScanMode] = useState("barcode"); // "barcode" or "vision"
    const [visionLoading, setVisionLoading] = useState(false);
    
    // Bulk scan states
    const [bulkScanDialogOpen, setBulkScanDialogOpen] = useState(false);
    const [bulkScanMode, setBulkScanMode] = useState("barcode"); // "barcode" or "vision"
    const [bulkScanError, setBulkScanError] = useState("");
    const [bulkScanPermissionLoading, setBulkScanPermissionLoading] = useState(false);
    const [bulkScanLookupLoading, setBulkScanLookupLoading] = useState(false);
    const [bulkVisionLoading, setBulkVisionLoading] = useState(false);
    const [bulkScannedCode, setBulkScannedCode] = useState("");
    const [scannerVisible, setScannerVisible] = useState(true);
    const visionCaptureRef = useRef(null);
    const scannedProducts = useSelector(state => state.products.scannedProducts);
    const [capacityEditDialogOpen, setCapacityEditDialogOpen] = useState(false);
    const [editingProductId, setEditingProductId] = useState(null);
    const [editingCapacity, setEditingCapacity] = useState(null);
    const [productEditDialogOpen, setProductEditDialogOpen] = useState(false);
    const [editingProduct, setEditingProduct] = useState(null);

    // Products list (for addons) filtered by category and inventory availability
    const selectedInventoryIds = formData?.inventory || [];
    const products = useSelector(state =>
        state.products.products
            .filter(product => product.item_category === "Addon")
            .filter(product => {
                if (!product.capacitydetails) return false;
                const capacities = Object.values(product.capacitydetails).flatMap(detail => detail.capacities || []);
                return capacities.some(capacity => selectedInventoryIds.includes(capacity.inventory_id));
            })
    );

    const criteria = [
        { name: 'Veg', value: 'veg' },
        { name: 'Non - veg', value: 'non-veg' },
    ];
// console.log("--------inventory---------->>>>>",inventory);
    // Helpers for Autocomplete selections
    const selectedInventoryOptions = (filteredInventory || []).filter(opt =>
        (formData.inventory || []).includes(opt.value)
    );
    const selectedCategoryOption = (category || []).find(c => c.value === formData.item_category) || null;
    const selectedSubCategoryOption = (subCategory || []).find(c => c.value === formData.item_sub_category) || null;
    const selectedCriteriaOption = (criteria || []).find(c => c.value === formData.item_criteria || c.name === formData.item_criteria) || null;
    const selectedAddonsOptions = (products || []).filter(p => (formData.addons || []).includes(p.id));

    // Legacy availability/time placeholders to avoid undefined references (availability UI removed)
    const [modalErrors, setModalErrors] = useState({ available_from: '', available_to: '' });
    const [openDateRangeModal, setOpenDateRangeModal] = useState(false);
    const [dateRangeContext, setDateRangeContext] = useState({ inventoryId: null, capIndex: null });
    const [modalStartDateTime, setModalStartDateTime] = useState(null);
    const [modalEndDateTime, setModalEndDateTime] = useState(null);
    const [modalDaysOfWeek, setModalDaysOfWeek] = useState([]);
    const [modalRepeatMode, setModalRepeatMode] = useState('year');
    const [modalError, setModalError] = useState('');
    const availabilityOptions = [];
    const daysOfWeek = [];
    const handleTimeChange = () => {};
    const handleStartDateChange = () => {};
    const handleRepeatModeChange = () => {};
    const calculateEndDate = () => null;
    const getLastDayOfMonth = () => null;
    const getLastDayOfYear = () => null;
    const DateTextField = React.useMemo(
        () => React.forwardRef((props, ref) => <TextField {...props} inputRef={ref} />),
        []
    );
    
    // Check if user can manage products (create, edit, delete)
    // Allow super_admin, admin, supervisor and merchant to see product management actions
    const canManageProducts = ['super_admin', 'admin', 'supervisor', 'merchant'].includes(user_role);
    const [openTimeModal, setOpenTimeModal] = useState(false);
    const [instructionOptions, setInstructionOptions] = useState([]); // [{ label, value }, ...]
    const [selectedInstructionIds, setSelectedInstructionIds] = useState([]); // [id,...]
    const prevSelectedInstructionIdsRef = useRef([]); // for diff on update
    // const products = useSelector(state => state.products.products.filter(product => product.item_category =='Addon'))


    useEffect(() => {
        if (formData.addons && formData.addons.length > 0) {
            const validAddons = products.map(p => p.id); // IDs of available addons
            const filteredAddons = formData.addons.filter(a => validAddons.includes(a));

            if (filteredAddons.length !== formData.addons.length) {
                setFormData(prev => ({
                    ...prev,
                    addons: filteredAddons
                }));
            }
        }
    }, [products, formData.addons, setFormData]);

    // console.log('full products------------>>',products)



    const idToOption = React.useMemo(
        () => new Map(instructionOptions.map(o => [o.value, o])),
        [instructionOptions]
    );

    // Build selected option objects from IDs (same refs as in options)
    const selectedOptions = React.useMemo(
        () => selectedInstructionIds.map(id => idToOption.get(id)).filter(Boolean),
        [selectedInstructionIds, idToOption]
    );

    useEffect(() => {
        const role = localStorage.getItem('role');
        const total_hub = JSON.parse(localStorage.getItem('hub')) || [];

        let filtered = [];

        if (role === 'merchant') {
            filtered = (inventory || [])
                .filter(inv => total_hub.includes(inv.id ?? inv.value))
                .map(inv => ({
                    ...inv,
                    value: inv.id ?? inv.value,
                    name: inv.place ?? inv.name ?? 'Not assigned hub',
                    disabled: false
                }));
        } else {
            filtered = (inventory || []).map(inv => {
                const invId = inv.id ?? inv.value;
                const isAssigned = total_hub.includes(invId);

                return {
                    ...inv,
                    value: invId,
                    name: inv.place ?? inv.name ?? 'Not assigned hub',
                    disabled: ['admin', 'supervisor', 'customer_engagement_admin'].includes(role)
                        ? !isAssigned
                        : false
                };
            });
        }

        setFilteredInventory(filtered);
    }, [inventory]);

    // console.log("role:", user_role);
    // console.log("filteredInventory:", filteredInventory);

    useEffect(()=>{
        getCategory()
        getSubCategory()
    },[authToken])

    // Load scanned products from localStorage on mount (only once)
    useEffect(() => {
        const saved = localStorage.getItem('scannedProducts');
        if (saved && scannedProducts.length === 0) {
            try {
                const parsed = JSON.parse(saved);
                parsed.forEach(product => {
                    dispatch(addScannedProduct(product));
                });
            } catch (e) {
                console.error("Failed to load scanned products from localStorage", e);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Only run on mount

    useEffect(()=>{
        const newcategory = actcategory.map(obj=>({
            name:obj.category_name,
            value:obj.category_name
        })

        )
        setCategory(newcategory)
    },[actcategory])
    useEffect(()=>{
        const newcategory = sub_category.map(obj=>({
            name:obj.subcategory_name,
            value:obj.subcategory_name
        })

        )
        setSubCategory(newcategory)
    },[sub_category])
    // console.log(category)

    const handleExtraPercentageChange = (invId, index, value) => {
        const updatedList = (formData.capacitydetails?.[invId] || []).map((item, i) => {
            if (i !== index) return item;

            const extraPercentage = value === '' ? 0 : parseFloat(value) || 0;
            const price = parseFloat(item.item_price) || 0;
            const priceWithExtra = price + (price * extraPercentage) / 100;

            return {
                ...item,
                extraPercentage: value === '' ? '' : extraPercentage,
                item_selling_price: priceWithExtra.toFixed(2), 
            };
        });

        setFormData((prev) => ({
            ...prev,
            capacitydetails: {
                ...prev.capacitydetails,
                [invId]: updatedList,
            }
        }));
    };
    
 

    useEffect(() => {
        const updatedCapacityDetails = {};

        Object.entries(formData.capacitydetails || {}).forEach(([invId, capacityList]) => {
            // ✅ ensure it's an array before calling .map()
            if (!Array.isArray(capacityList)) {
                updatedCapacityDetails[invId] = []; // fallback empty array
                return;
            }

            updatedCapacityDetails[invId] = capacityList.map((item) => {
                const price = parseFloat(item.item_price) || 0;
                const extraPercentage = parseFloat(item.extraPercentage) || 0;
                const priceWithExtra = price + (price * extraPercentage) / 100;

                return {
                    ...item,
                    item_selling_price: priceWithExtra.toFixed(2),
                };
            });
        });

        setFormData((prev) => ({
            ...prev,
            capacitydetails: updatedCapacityDetails,
        }));
    }, []);
    
    
    useEffect(() => {
        // console.log(productDetails)
        setFormData(productDetails)
        setBarcodeImageUrl(productDetails?.barcode_image || "");
        dispatch(updateUpdatedDate(null))
    }, [productDetails])
    useEffect(() => {
        if (edit) {
            // Use images field from model first, then fall back to image_urls
            const imageSources = productDetails?.images || productDetails?.image_urls || [];
            setImagePreviews(imageSources);
            
            const convert = async () => {
                const results = await Promise.allSettled(
                    imageSources.map(async (url) => {
                        try {
                        const response = await fetch(url);
                            if (!response.ok) throw new Error(`fetch failed: ${response.status}`);
                        const blob = await response.blob();
                        const file = url.split('/').pop();
                            return new File([blob], file || "image.jpg", { type: blob.type || "image/jpeg" });
                        } catch (err) {
                            console.warn("Image fetch failed", url, err);
                            return null;
                        }
                    })
                );
                const fetchedImages = results
                    .filter(r => r.status === "fulfilled" && r.value)
                    .map(r => r.value);
                //console.log(fetchedImages)
                setFormData(prevData => ({
                    ...prevData,
                    images: fetchedImages
                }));
            };

            convert();

            // console.log('[ProductDetails useEffect] ===== EDIT MODE ACTIVATED =====');
            // console.log('[ProductDetails useEffect] Full productDetails:', productDetails);
            // console.log('[ProductDetails useEffect] productDetails.capacitydetails:', productDetails.capacitydetails);
            // console.log('[ProductDetails useEffect] productDetails.inventory_id:', productDetails.inventory_id);
            // console.log('[ProductDetails useEffect] Capacitydetails type:', Array.isArray(productDetails.capacitydetails) ? 'ARRAY' : typeof productDetails.capacitydetails);
            // console.log('[ProductDetails useEffect] Role:', localStorage.getItem('role'));

            // Extract inventory IDs and transform capacitydetails if needed
            let extractedInventoryIds = [];
            let transformedCapacityDetails = productDetails.capacitydetails;
            
            if (Array.isArray(productDetails.capacitydetails)) {
                // console.log('[ProductDetails useEffect] Processing ARRAY format (merchant)');
                // For merchant: capacitydetails is an array, but inventory_id is at root level
                const inventoryId = productDetails.inventory_id;
                // console.log('[ProductDetails useEffect] Using root inventory_id:', inventoryId);
                
                if (inventoryId) {
                    transformedCapacityDetails = {
                        [inventoryId]: productDetails.capacitydetails
                    };
                    extractedInventoryIds = [parseInt(inventoryId)];
                } else {
                    // Fallback: try to extract from array items
                    transformedCapacityDetails = {};
                    productDetails.capacitydetails.forEach((cap, index) => {
                        // console.log(`[ProductDetails useEffect] Array item ${index}:`, cap);
                        const invId = cap.inventory_id || inventoryId;
                        if (invId) {
                            if (!transformedCapacityDetails[invId]) {
                                transformedCapacityDetails[invId] = [];
                            }
                            transformedCapacityDetails[invId].push(cap);
                        } else {
                            console.warn(`[ProductDetails useEffect] Array item ${index} has no inventory_id:`, cap);
                        }
                    });
                    extractedInventoryIds = Object.keys(transformedCapacityDetails).map(id => parseInt(id));
                }
            } else if (productDetails.capacitydetails && typeof productDetails.capacitydetails === 'object') {
                // console.log('[ProductDetails useEffect] Processing OBJECT format (super_admin)');
                // For super_admin: capacitydetails is already an object with hub IDs as keys
                // But might have nested structure with 'capacities' array, so flatten it
                const flattened = {};
                Object.entries(productDetails.capacitydetails).forEach(([invId, invData]) => {
                    // console.log(`[ProductDetails useEffect] Object entry - invId: ${invId}, invData:`, invData);
                    if (Array.isArray(invData)) {
                        flattened[invId] = invData;
                    } else if (invData && invData.capacities) {
                        flattened[invId] = invData.capacities;
                    } else {
                        flattened[invId] = invData;
                    }
                });
                transformedCapacityDetails = flattened;
                extractedInventoryIds = Object.keys(transformedCapacityDetails).map(id => parseInt(id));
            } else {
                console.warn('[ProductDetails useEffect] capacitydetails is neither array nor object:', productDetails.capacitydetails);
            }

            // console.log('[ProductDetails useEffect] Transformed capacitydetails:', transformedCapacityDetails);
            // console.log('[ProductDetails useEffect] Extracted inventory IDs:', extractedInventoryIds);
            // console.log('[ProductDetails useEffect] Available filteredInventory:', filteredInventory);
            // console.log('[ProductDetails useEffect] filteredInventory length:', filteredInventory?.length);

            // Check if inventory options match extracted IDs
            if (filteredInventory && extractedInventoryIds.length > 0) {
                const matchingOptions = filteredInventory.filter(inv => extractedInventoryIds.includes(inv.value));
                // console.log('[ProductDetails useEffect] Matching inventory options:', matchingOptions);
                // console.log('[ProductDetails useEffect] Matching options count:', matchingOptions.length);
            }

            setFormData(prevData => {
                const newFormData = {
                    ...prevData,
                    ...productDetails,
                    capacitydetails: transformedCapacityDetails,
                    inventory: extractedInventoryIds,
                };
                // console.log('[ProductDetails useEffect] Setting formData with inventory:', newFormData.inventory);
                // console.log('[ProductDetails useEffect] ===== FORMDATA SET =====');
                return newFormData;
            });
        }
    }, [edit]);
    //console.log(productDetails)

    const handleInvChange = (selectedInventories) => {

        // Initialize capacitydetails for each selected inventory
        const newCapacityDetails = { ...formData.capacitydetails };

        selectedInventories.forEach(inv => {
            if (!newCapacityDetails[inv] || newCapacityDetails[inv].length === 0) {
                newCapacityDetails[inv] = [
                    {
                        item_price: "",
                        item_available: true,
                        item_capacity: "",
                        item_quantity: "",
                        item_tax: "",
                        item_selling_price: "",
                        item_offers_price: 0.00,
                        extraPercentage: "",
                        capacityValue: "",
                        item_special_offer: "",
                        unit: "",
                    },
                ];
            }
        });

        // Remove capacity forms for unselected inventories
        Object.keys(newCapacityDetails).forEach(inv => {
            if (!selectedInventories.includes(parseInt(inv))) {
                delete newCapacityDetails[inv];
            }
        });

        setFormData({
            ...formData,
            inventory: selectedInventories,
            capacitydetails: newCapacityDetails,
        });

        setErrors(prev => ({ ...prev, inventory: null }));
    };

    useEffect(() => {
    if (!formData.capacitydetails || typeof formData.capacitydetails !== 'object') {
        setFormData((prev) => ({
            ...prev,
            capacitydetails: {}
        }));
    }
}, [formData.capacitydetails]);


const handleChange = (e) => {
        if (e.htmlValue !== undefined) {
            const name = e.target ? e.target.name : "item_details";
            const value = e.htmlValue;

            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        } else {
            const name = e.target.name;
            let value;

            if (name === "shinos_choice" || name === "bogo") {
                value = e.target.checked;
            }  else if (name === "addons") {
            value = e.value || [];
            // console.log("Selected addons========>", value);
        } else {
                value = e.target.value;
            }

            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };
    // const handleCapacityChange = (index, e) => {
    //     const updatedCapacityDetails = formData?.capacitydetails?.map((item, i) =>
    //       i === index ? { ...item, [e.target.name]: e.target.value } : item
    //     );
    //     //console.log(updatedCapacityDetails)
    //     setFormData({ ...formData, capacitydetails: updatedCapacityDetails });
    //   }

    // console.log('data-------?',formData)
      
    const handleCapacityChange = (invId, index, e) => {
    let name, value;

    if (e?.target) {
        name = e.target.name;
        value = e.target.value;
    } else if (e?.value !== undefined && e?.originalEvent) {
        name = e.originalEvent.target.name;
        value = e.value;
    } else {
        console.warn("Unknown event format:", e);
        return;
    }

    setFormData((prevFormData) => {
        const updatedItem = {
            ...prevFormData.capacitydetails[invId][index],
            [name]: value,
        };

        // Recalculate dependent values
        if (name === 'item_price' || name === 'extraPercentage') {
            const price = parseFloat(updatedItem.item_price) || 0;
            const extra = parseFloat(updatedItem.extraPercentage) || 0;
            updatedItem.item_selling_price = (price + (price * extra) / 100).toFixed(2);
        }

        if (name === 'item_special_offer') {
            updatedItem.item_offers_price = value
                ? (parseFloat(updatedItem.item_selling_price) - ((parseFloat(value) / 100) * parseFloat(updatedItem.item_selling_price))).toFixed(2)
                : 0;
        }

        if (name === 'capacityValue' || name === 'unit') {
            updatedItem.item_capacity = `${updatedItem.capacityValue ?? ''} ${updatedItem.unit ?? ''}`.trim();
        }

        const updatedList = [...prevFormData.capacitydetails[invId]];
        updatedList[index] = updatedItem;

        return {
            ...prevFormData,
            capacitydetails: {
                ...prevFormData.capacitydetails,
                [invId]: updatedList,
            },
        };
    });
};


    const handleAddCapacity = (invId) => {
        const currentCapacities = formData.capacitydetails?.[invId] || [];

        const newCapacity = {
            item_price: "",
            item_available: true,
            item_capacity: "",
            item_quantity: "",
            item_tax: "",
            item_selling_price: "",
            item_offers_price: 0.00,
            extraPercentage: "",
            capacityValue: "",
            unit: "",
            item_special_offer:""
        };
        setFormData((prevFormData) => ({
            ...prevFormData,
            capacitydetails: {
                ...prevFormData.capacitydetails,
                [invId]: [...currentCapacities, newCapacity],
            },
        }));
    };

const handleRemoveCapacity = (invId, index) => {
    const updatedCapacities = formData.capacitydetails[invId].filter((_, i) => i !== index);

    setFormData((prevFormData) => ({
        ...prevFormData,
        capacitydetails: {
            ...prevFormData.capacitydetails,
            [invId]: updatedCapacities,
        },
    }));
};


    // const category = [
    //     { name: 'Food', value: 'food' },
    //     { name: 'Meat', value: 'meat' },
    //     { name: 'Vegetables', value: 'vegetables' },
    //     { name: 'Provisions', value: 'provisions' },
    //     { name: 'Oil & Sauces', value: 'Oil & Sauces' },
    //     { name: 'Dairy & Breads', value: 'Dairy & Breads' },
    //     { name: 'Refreshing Beverages', value: 'Refreshing Beverages'},
    //     { name: 'kitchen appliances', value: 'kitchen appliances'},
    //     // { name: 'Mojitos', value: 'Mojitos' },
    //     // { name: 'Cool Drinks', value: 'Cool Drinks' },
    // ];
    const capacity = [
        { name: 'grams', value: 'gms' },
        { name: 'kilogram', value: 'kg' },
        { name: 'litre', value: 'ltr' },
        { name: 'box', value: 'box' },
        { name: 'cups', value: 'cups' },
        { name: 'ml', value: 'ml' },
        { name: 'pieces', value: 'pieces' },
        { name: 'bunch', value: 'bunch' },
        { name: 'packet', value: 'packet' },
        { name: 'bottle', value: 'bottle' },
        { name: 'offer', value: 'offer' },
    ];
    const availability = [
        { name: 'Available', value: true },
        { name: 'Out of stock', value: false },
    ];

    const handleImageChange = (e) => {
        const files = Array.from(e.target.files);
        setFormData({
            ...formData,
            images: [...formData?.images, ...files]
        });
        if (edit) {
            const url = URL.createObjectURL(e.target.files[0]);
            setImagePreviews(prev => ([...prev, url]));
        }else{
            const previews = files?.map((file) => URL.createObjectURL(file));
            setImagePreviews(prev => ([...prev, ...previews]));
        }
        // dispatch(updateProductDetail('images', files));
    };

    // useEffect(() => {
    //     if (formData?.images?.length > 0 && !edit && !modal) {
    //         console.log("in photo");
    //         const previews = formData.images.map((file) => URL.createObjectURL(file));
    //         setImagePreviews(previews);
    //     }
    //     return () => {
    //         formData?.images?.forEach((file) => URL.revokeObjectURL(file));
    //     };
    // }, [formData?.images, edit,modal]);
    const handleRemoveImage = (index) => {
        const newImages = formData?.images?.filter((_, i) => i !== index);
        // console.log(newImages)
        setFormData((prevData) => ({ ...prevData, images: newImages??[] }));
        if (!edit) {
            setImagePreviews(formData?.images?.filter((_, i) => i !== index));
        } else {
            const newImagesurls = formData?.image_urls?.filter((_, i) => i !== index);
            setFormData((prevData) => ({ ...prevData, images: newImages??[],image_urls:newImagesurls }));
            setImagePreviews(imagePreviews?.filter((_, i) => i !== index));
        }

        // dispatch(updateProductDetail('images', formData.images.filter((_, i) => i !== index)));
    };

    const handleDownloadBulkSample = () => {
        const productsSheet = [
            ["item_name","product_barcode", "item_description", "item_category", "item_sub_category", "item_criteria", "item_details", "shinos_choice", "bogo", "is_active", "image_urls"],
            ["Sample Product","000000000", "Short description", "CategoryName", "SubCategoryName", "veg", "Long form details", true, false, true, "https://example.com/img1.webp, https://example.com/img2.webp"],
        ];

        const capacitiesSheet = [
            ["product_row", "capacityValue", "unit", "item_price", "item_tax", "item_available", "extraPercentage", "item_offers_price", "item_selling_price", "item_special_offer"],
            [2, "250", "gms", 100, 5, true, 0, 95, 100, 0],
        ];

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(productsSheet), "Products");
        XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(capacitiesSheet), "Capacities");
        XLSX.writeFile(wb, "bulk_products_sample.xlsx");
    };

    const handleBulkFileChange = async (event) => {
        const file = event.target.files?.[0];
        if (!file) return;
        if (!file.name.toLowerCase().endsWith(".xlsx")) {
            toast.current.show({ severity: 'error', summary: 'Invalid file', detail: 'Please upload a .xlsx file', life: 3000 });
            return;
        }
        setBulkUploading(true);
        setBulkErrors([]);
        try {
            const formDataUpload = new FormData();
            formDataUpload.append("file", file);
            // inventory_id now sent with payload instead of sheet
            const inventoryId = selectedHub || (Array.isArray(filteredInventory) && filteredInventory[0]?.value);
            if (inventoryId) {
                formDataUpload.append("inventory_id", inventoryId);
            }
            const res = await CustomAxios.post(`products/bulk-upload/`, formDataUpload);
            const successCount = res?.data?.successCount || 0;
            const failureCount = res?.data?.failureCount || 0;
            const errorList = res?.data?.errors || [];
            if (successCount > 0) {
                toast.current.show({ severity: 'success', summary: 'Bulk upload', detail: `${successCount} products added successfully`, life: 4000 });
                getProducts();
            }
            if (failureCount > 0 && errorList.length) {
                setBulkErrors(errorList);
                const missingCap = errorList.filter(e => (e?.message || "").toLowerCase().includes("missing capacity"));
                if (missingCap.length) {
                    const msg = missingCap.map(e => `Row ${e?.row}: ${e?.message}`).slice(0, 3).join(" | ");
                    toast.current.show({ severity: 'error', summary: 'Missing capacities', detail: msg || `${missingCap.length} product(s) missing capacity`, life: 6000 });
                } else {
                    toast.current.show({ severity: 'warn', summary: 'Partial failures', detail: `${failureCount} rows failed. See details below.`, life: 5000 });
                }
            } else {
                setBulkErrors([]);
            }
            setBulkDialogOpen(false);
        } catch (error) {
            const detail = error?.response?.data?.error || error?.response?.data?.message || "Bulk upload failed";
            toast.current.show({ severity: 'error', summary: 'Bulk upload failed', detail, life: 4000 });
        } finally {
            setBulkUploading(false);
            if (bulkFileInputRef.current) {
                bulkFileInputRef.current.value = null;
            }
        }
    };

    const openBulkUpload = () => {
        setBulkDialogOpen(true);
        setBulkErrors([]);
    };

    const closeBulkUpload = () => {
        setBulkDialogOpen(false);
        setBulkErrors([]);
        if (bulkFileInputRef.current) {
            bulkFileInputRef.current.value = null;
        }
    };

    const triggerBulkFilePicker = () => {
        if (bulkFileInputRef.current) {
            bulkFileInputRef.current.click();
        }
    };

    const openScanAdd = async () => {
        setScanPermissionLoading(true);
        setScannedCode("");
        setScanError("");
        try {
            if (navigator?.mediaDevices?.getUserMedia) {
                const stream = await navigator.mediaDevices.getUserMedia({ video: true });
                // Immediately stop tracks; BarcodeScanner will request again as needed
                stream.getTracks().forEach((track) => track.stop());
            }
            setScanDialogOpen(true);
        } catch (err) {
            const msg = err?.message || "Camera permission denied or unavailable";
            setScanError(msg);
            setScanDialogOpen(true); // still open to allow manual entry fallback
        } finally {
            setScanPermissionLoading(false);
        }
    };

    const closeScanAdd = () => {
        setScanDialogOpen(false);
        setScanError("");
    };

    const downloadImagesAsFiles = async (urls = []) => {
        const results = await Promise.allSettled(
            urls.map(async (url) => {
                const res = await fetch(url);
                if (!res.ok) throw new Error(`fetch failed: ${res.status}`);
                const blob = await res.blob();
                const fileName = url.split("/").pop() || "image.jpg";
                return new File([blob], fileName, { type: blob.type || "image/jpeg" });
            })
        );
        return results
            .filter(r => r.status === "fulfilled" && r.value)
            .map(r => r.value);
    };

    const buildLongDescription = (prod = {}) => {
        const omitKeys = new Set(["title", "description", "images"]);
        return Object.entries(prod)
            .filter(([k, v]) => !omitKeys.has(k) && v !== undefined && v !== null && `${v}`.trim() !== "")
            .map(([k, v]) => {
                const val = typeof v === "object" ? JSON.stringify(v) : v;
                return `${k}: ${val}`;
            })
            .join("\n");
    };

    const scanLastRef = useRef({ code: "", ts: 0 });
    const scanInFlightRef = useRef(false);

    const handleScanDetected = async (code) => {
        const cleaned = `${code || ""}`.trim();
        setScannedCode(cleaned);
        const now = Date.now();
        if (!cleaned) {
            setScanError("Scanned/entered code is empty");
            return;
        }
        if (scanInFlightRef.current) {
            setScanError("Lookup in progress, please wait...");
            return;
        }
        if (cleaned === scanLastRef.current.code && now - scanLastRef.current.ts < 2000) {
            // duplicate within 2s, ignore
            return;
        }
        scanLastRef.current = { code: cleaned, ts: now };
        scanInFlightRef.current = true;
        setScanLookupLoading(true);
        setScanError("");

        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 5000);
        try {
            const resp = await CustomAxios.get(`barcode-lookup/`, {
                params: { code: cleaned },
                signal: controller.signal
            });
            const product = resp?.data?.items?.[0];
            if (!product) {
                throw new Error("No product info found for this barcode");
            }
            const title = product.title || cleaned;
            const shortDesc = product.description || "";
            const imageUrls = Array.isArray(product.images) ? product.images.slice(0, 3) : [];
            const longDesc = buildLongDescription(product);

            const overrides = {
                item_name: title,
                item_description: shortDesc,
                item_details: longDesc,
                image_urls: imageUrls,
                product_barcode:code,
                images: [] // keep empty so we send URLs, not files, for barcode flow
            };

            handleOpen("", overrides);
            setImagePreviews(imageUrls);
        } catch (err) {
            const msg = err?.name === "AbortError"
                ? "Lookup timed out"
                : err?.response?.data?.message || err?.message || "Lookup failed";
            setScanError(msg);
            // Still allow manual flow with just SKU prefill
            handleOpen("");
        } finally {
            clearTimeout(timeoutId);
            scanInFlightRef.current = false;
            setScanLookupLoading(false);
            setScanDialogOpen(false);
        }
    };

    const handleManualScanSubmit = () => {
        handleScanDetected(scannedCode);
    };

    const handleScanError = (message) => {
        if (message) {
            setScanError(message);
        }
    };

    // Vision AI product detection handler
    const handleVisionDetected = async (productData) => {
        setVisionLoading(false);
        setScanError("");
        
        if (!productData) {
            setScanError("No product information detected");
            return;
        }

        const overrides = {
            item_name: productData.name || "",
            item_description: productData.description || "",
            item_category: productData.category || "",
            item_details: productData.details || "",
            product_barcode:productData.barcode,
            image_urls: productData.images || [],
            images: []
        };

        // If price is available, we can set it in capacity details
        if (productData.price) {
            overrides.capacitydetails = [{
                item_price: productData.price,
                item_available: true,
                item_capacity: "",
                item_quantity: "",
                item_tax: "",
                item_selling_price: productData.price,
                item_offers_price: 0.00,
                extraPercentage: "",
                capacityValue: "",
                item_special_offer: "",
                unit: ""
            }];
        }

        handleOpen("", overrides);
        if (productData.images?.length > 0) {
            setImagePreviews(productData.images);
        }
        setScanDialogOpen(false);
    };

    const handleVisionError = (message) => {
        setVisionLoading(false);
        setScanError(message || "Vision detection failed");
    };

    // Bulk scan handlers
    const openBulkScanDialog = async () => {
        setBulkScanPermissionLoading(true);
        setBulkScanError("");
        setScannerVisible(true); // Reset scanner visibility when opening
        try {
            if (navigator?.mediaDevices?.getUserMedia) {
                const stream = await navigator.mediaDevices.getUserMedia({ video: true });
                stream.getTracks().forEach((track) => track.stop());
            }
            setBulkScanDialogOpen(true);
            // Load from localStorage
            const saved = localStorage.getItem('scannedProducts');
            if (saved) {
                try {
                    const parsed = JSON.parse(saved);
                    parsed.forEach(product => dispatch(addScannedProduct(product)));
                } catch (e) {
                    console.error("Failed to load scanned products from localStorage", e);
                }
            }
        } catch (err) {
            const msg = err?.message || "Camera permission denied or unavailable";
            setBulkScanError(msg);
            setBulkScanDialogOpen(true);
        } finally {
            setBulkScanPermissionLoading(false);
        }
    };

    const closeBulkScanDialog = () => {
        setBulkScanDialogOpen(false);
        setBulkScanError("");
    };

    // Save scanned products to localStorage whenever they change
    useEffect(() => {
        if (scannedProducts.length > 0) {
            localStorage.setItem('scannedProducts', JSON.stringify(scannedProducts));
        } else {
            localStorage.removeItem('scannedProducts');
        }
    }, [scannedProducts]);

    const handleBulkScanDetected = async (code) => {
        const cleaned = `${code || ""}`.trim();
        if (!cleaned) {
            setBulkScanError("Scanned/entered code is empty");
            return;
        }
        setBulkScanLookupLoading(true);
        setBulkScanError("");

        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 5000);
        try {
            const resp = await CustomAxios.get(`barcode-lookup/`, {
                params: { code: cleaned },
                signal: controller.signal
            });
            const product = resp?.data?.items?.[0];
            if (!product) {
                throw new Error("No product info found for this barcode");
            }
            const title = product.title || cleaned;
            const shortDesc = product.description || "";
            const imageUrls = Array.isArray(product.images) ? product.images.slice(0, 3) : [];
            const longDesc = buildLongDescription(product);

            // Default inventory to selectedHub (ensure it's an array)
            const defaultInventoryId = selectedHub || (Array.isArray(filteredInventory) && filteredInventory[0]?.value ? filteredInventory[0].value : null);
            const inventoryArray = defaultInventoryId ? [defaultInventoryId] : [];

            const scannedProduct = {
                sku_code: cleaned,
                item_name: title,
                item_description: shortDesc,
                item_details: longDesc,
                image_urls: imageUrls,
                images: [],
                item_category: "",
                item_sub_category: "",
                item_criteria: "",
                inventory: inventoryArray,
                shinos_choice: false,
                bogo: false,
                is_active: true,
                // Structure capacitydetails as object with inventory ID as key (for selectedHub only)
                capacitydetails: defaultInventoryId ? {
                    [defaultInventoryId]: [{
                        item_price: "",
                        item_available: true,
                        item_capacity: "",
                        item_quantity: "",
                        item_tax: "",
                        item_selling_price: "",
                        item_offers_price: 0.00,
                        extraPercentage: "",
                        capacityValue: "",
                        unit: "",
                        item_special_offer: ""
                    }]
                } : {}
            };

            dispatch(addScannedProduct(scannedProduct));
            toast.current.show({ severity: 'success', summary: 'Product scanned', detail: `${title} added to list`, life: 2000 });
        } catch (err) {
            const msg = err?.name === "AbortError"
                ? "Lookup timed out"
                : err?.response?.data?.message || err?.message || "Lookup failed";
            setBulkScanError(msg);
            toast.current.show({ severity: 'error', summary: 'Scan failed', detail: msg, life: 3000 });
        } finally {
            clearTimeout(timeoutId);
            setBulkScanLookupLoading(false);
        }
    };

    const handleBulkVisionDetected = async (productData) => {
        setBulkVisionLoading(false);
        setBulkScanError("");
        
        if (!productData) {
            setBulkScanError("No product information detected");
            return;
        }

        // Default inventory to selectedHub (ensure it's an array)
        const defaultInventoryId = selectedHub || (Array.isArray(filteredInventory) && filteredInventory[0]?.value ? filteredInventory[0].value : null);
        const inventoryArray = defaultInventoryId ? [defaultInventoryId] : [];

        const scannedProduct = {
            sku_code: productData.barcode || "",
            item_name: productData.name || "",
            item_description: productData.description || "",
            item_details: productData.details || "",
            image_urls: productData.images || [],
            images: [],
            item_category: productData.category || "",
            item_sub_category: "",
            item_criteria: "",
            inventory: inventoryArray,
            shinos_choice: false,
            bogo: false,
            is_active: true,
            // Structure capacitydetails as object with inventory ID as key (for selectedHub only)
            capacitydetails: defaultInventoryId ? {
                [defaultInventoryId]: productData.price ? [{
                    item_price: productData.price,
                    item_available: true,
                    item_capacity: productData.capacity || "",
                    item_quantity: "",
                    item_tax: "",
                    item_selling_price: productData.price,
                    item_offers_price: 0.00,
                    extraPercentage: "",
                    capacityValue: "",
                    unit: "",
                    item_special_offer: ""
                }] : [{
                    item_price: "",
                    item_available: true,
                    item_capacity: "",
                    item_quantity: "",
                    item_tax: "",
                    item_selling_price: "",
                    item_offers_price: 0.00,
                    extraPercentage: "",
                    capacityValue: "",
                    unit: "",
                    item_special_offer: ""
                }]
            } : {}
        };

        dispatch(addScannedProduct(scannedProduct));
        toast.current.show({ severity: 'success', summary: 'Product identified', detail: `${productData.name || 'Product'} added to list`, life: 2000 });
    };

    const handleBulkVisionError = (message) => {
        setBulkVisionLoading(false);
        setBulkScanError(message || "Vision detection failed");
    };

    const handleRemoveScannedProduct = (id) => {
        dispatch(removeScannedProduct(id));
        toast.current.show({ severity: 'info', summary: 'Removed', detail: 'Product removed from list', life: 2000 });
    };

    const handleEditScannedProductCapacity = (productId) => {
        const product = scannedProducts.find(p => p.id === productId);
        if (product) {
            setEditingProductId(productId);
            // Get capacity details for selectedHub (first inventory in the array)
            const inventoryId = product.inventory?.[0] || selectedHub;
            const capacityDetails = product.capacitydetails;
            
            // Handle both old format (array) and new format (object with inventory keys)
            let capacity = null;
            if (Array.isArray(capacityDetails)) {
                capacity = capacityDetails[0];
            } else if (capacityDetails && typeof capacityDetails === 'object') {
                capacity = capacityDetails[inventoryId]?.[0] || capacityDetails[Object.keys(capacityDetails)[0]]?.[0];
            }
            
            setEditingCapacity(capacity || {
                item_price: "",
                item_available: true,
                item_capacity: "",
                item_quantity: "",
                item_tax: "",
                item_selling_price: "",
                item_offers_price: 0.00,
                extraPercentage: "",
                capacityValue: "",
                unit: "",
                item_special_offer: ""
            });
            setCapacityEditDialogOpen(true);
        }
    };

    const handleSaveCapacityDetails = () => {
        if (editingProductId && editingCapacity) {
            const product = scannedProducts.find(p => p.id === editingProductId);
            if (!product) return;

            // Calculate selling price if price and extraPercentage are provided
            if (editingCapacity.item_price && editingCapacity.extraPercentage) {
                const price = parseFloat(editingCapacity.item_price) || 0;
                const extra = parseFloat(editingCapacity.extraPercentage) || 0;
                editingCapacity.item_selling_price = (price + (price * extra) / 100).toFixed(2);
            }
            
            // Build capacity string
            if (editingCapacity.capacityValue && editingCapacity.unit) {
                editingCapacity.item_capacity = `${editingCapacity.capacityValue} ${editingCapacity.unit}`.trim();
            }

            // Get inventory ID (selectedHub or first inventory)
            const inventoryId = product.inventory?.[0] || selectedHub;
            
            // Update capacitydetails as object with inventory ID as key
            const updatedCapacityDetails = {
                ...(product.capacitydetails || {}),
                [inventoryId]: [editingCapacity]
            };

            dispatch(updateScannedProduct({
                id: editingProductId,
                updates: {
                    capacitydetails: updatedCapacityDetails
                }
            }));
            setCapacityEditDialogOpen(false);
            setEditingProductId(null);
            setEditingCapacity(null);
            toast.current.show({ severity: 'success', summary: 'Updated', detail: 'Capacity details saved', life: 2000 });
        }
    };

    const handleCapacityFieldChange = (field, value) => {
        setEditingCapacity(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleEditScannedProduct = (productId) => {
        const product = scannedProducts.find(p => p.id === productId);
        if (product) {
            setEditingProductId(productId);
            // Ensure inventory defaults to selectedHub if not set
            const productInventory = product.inventory && product.inventory.length > 0 
                ? product.inventory 
                : (selectedHub ? [selectedHub] : []);
            
            // Ensure capacitydetails structure matches inventory
            let productCapacityDetails = product.capacitydetails || {};
            if (Array.isArray(productCapacityDetails)) {
                // Convert old array format to new object format
                const inventoryId = productInventory[0] || selectedHub;
                if (inventoryId) {
                    productCapacityDetails = {
                        [inventoryId]: productCapacityDetails
                    };
                }
            } else if (!productCapacityDetails || Object.keys(productCapacityDetails).length === 0) {
                // Initialize with selectedHub if empty
                const inventoryId = productInventory[0] || selectedHub;
                if (inventoryId) {
                    productCapacityDetails = {
                        [inventoryId]: [{
                            item_price: "",
                            item_available: true,
                            item_capacity: "",
                            item_quantity: "",
                            item_tax: "",
                            item_selling_price: "",
                            item_offers_price: 0.00,
                            extraPercentage: "",
                            capacityValue: "",
                            unit: "",
                            item_special_offer: ""
                        }]
                    };
                }
            }
            
            setEditingProduct({ 
                ...product, 
                inventory: productInventory,
                capacitydetails: productCapacityDetails
            });
            setProductEditDialogOpen(true);
        }
    };

    const handleSaveProductDetails = () => {
        if (editingProductId && editingProduct) {
            dispatch(updateScannedProduct({
                id: editingProductId,
                updates: editingProduct
            }));
            setProductEditDialogOpen(false);
            setEditingProductId(null);
            setEditingProduct(null);
            toast.current.show({ severity: 'success', summary: 'Updated', detail: 'Product details saved', life: 2000 });
        }
    };

    const convertScannedProductsToExcel = () => {
        if (scannedProducts.length === 0) {
            toast.current.show({ severity: 'warn', summary: 'No products', detail: 'Please scan some products first', life: 3000 });
            return null;
        }

        // Products sheet
        const productsSheet = [
            ["item_name", "product_barcode", "item_description", "item_details", "item_category", "item_sub_category", "item_criteria", "shinos_choice", "bogo", "is_active", "image_urls"],
            ...scannedProducts.map((product, index) => [
                product.item_name || "",
                product.sku_code || "",
                product.item_description || "",
                product.item_description || "",
                product.item_category || "",
                product.item_sub_category || "",
                product.item_criteria || "",
                product.shinos_choice || false,
                product.bogo || false,
                product.is_active !== false,
                (product.image_urls || []).join(", ")
            ])
        ];

        // Capacities sheet
        const capacitiesSheet = [
            ["product_row", "capacityValue", "unit", "item_price", "item_tax", "item_available", "extraPercentage", "item_offers_price", "item_selling_price", "item_special_offer"],
        ];

        scannedProducts.forEach((product, productIndex) => {
            const capacityDetails = product.capacitydetails || {};
            const inventoryId = product.inventory?.[0] || selectedHub;
            
            // Handle both old format (array) and new format (object with inventory keys)
            let capacities = [];
            if (Array.isArray(capacityDetails)) {
                capacities = capacityDetails;
            } else if (capacityDetails && typeof capacityDetails === 'object') {
                // Get capacities for the selectedHub inventory
                capacities = capacityDetails[inventoryId] || capacityDetails[Object.keys(capacityDetails)[0]] || [];
            }
            
            capacities.forEach((cap) => {
                capacitiesSheet.push([
                    productIndex + 2, // +2 because row 1 is header, row 2 is first product
                    cap.capacityValue || "",
                    cap.unit || "",
                    cap.item_price || "",
                    cap.item_tax || "",
                    cap.item_available !== false,
                    cap.extraPercentage || 0,
                    cap.item_offers_price || 0,
                    cap.item_selling_price || "",
                    cap.item_special_offer || 0
                ]);
            });
        });

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(productsSheet), "Products");
        XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(capacitiesSheet), "Capacities");
        
        return wb;
    };

    const handleBulkSaveScannedProducts = async () => {
        if (scannedProducts.length === 0) {
            toast.current.show({ severity: 'warn', summary: 'No products', detail: 'Please scan some products first', life: 3000 });
            return;
        }

        setBulkUploading(true);
        setBulkErrors([]);
        try {
            const wb = convertScannedProductsToExcel();
            if (!wb) return;

            // Convert workbook to blob
            const excelBuffer = XLSX.write(wb, { type: 'array', bookType: 'xlsx' });
            const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const file = new File([blob], `bulk_scan_${Date.now()}.xlsx`, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

            const formDataUpload = new FormData();
            formDataUpload.append("file", file);
            const inventoryId = selectedHub || (Array.isArray(filteredInventory) && filteredInventory[0]?.value);
            if (inventoryId) {
                formDataUpload.append("inventory_id", inventoryId);
            }

            const res = await CustomAxios.post(`products/bulk-upload/`, formDataUpload);
            const successCount = res?.data?.successCount || 0;
            const failureCount = res?.data?.failureCount || 0;
            const errorList = res?.data?.errors || [];
            
            if (successCount > 0) {
                toast.current.show({ severity: 'success', summary: 'Bulk upload', detail: `${successCount} products added successfully`, life: 4000 });
                getProducts();
                dispatch(clearScannedProducts());
                localStorage.removeItem('scannedProducts');
                setBulkScanDialogOpen(false);
            }
            if (failureCount > 0 && errorList.length) {
                setBulkErrors(errorList);
                const missingCap = errorList.filter(e => (e?.message || "").toLowerCase().includes("missing capacity"));
                if (missingCap.length) {
                    const msg = missingCap.map(e => `Row ${e?.row}: ${e?.message}`).slice(0, 3).join(" | ");
                    toast.current.show({ severity: 'error', summary: 'Missing capacities', detail: msg || `${missingCap.length} product(s) missing capacity`, life: 6000 });
                } else {
                    toast.current.show({ severity: 'warn', summary: 'Partial failures', detail: `${failureCount} rows failed. See details below.`, life: 5000 });
                }
            } else {
                setBulkErrors([]);
            }
        } catch (error) {
            const detail = error?.response?.data?.error || error?.response?.data?.message || "Bulk upload failed";
            toast.current.show({ severity: 'error', summary: 'Bulk upload failed', detail, life: 4000 });
        } finally {
            setBulkUploading(false);
        }
    };

    const handleCategorySelect = (_e, value) => {
        setFormData(prev => ({
            ...prev,
            item_category: value?.value || "",
            item_sub_category: "" // reset subcategory on category change
        }));
    };

    const handleSubCategorySelect = (_e, value) => {
        setFormData(prev => ({
            ...prev,
            item_sub_category: value?.value || ""
        }));
    };

    const handleCriteriaSelect = (_e, value) => {
        setFormData(prev => ({
            ...prev,
            item_criteria: value?.value || value?.name || ""
        }));
    };

    const handleInventorySelect = (_e, value) => {
        const selectedInventories = value.map(v => v.value);
        handleInvChange(selectedInventories);
    };

    const handleAddonsSelect = (_e, value) => {
        const selectedIds = value.map(v => v.id);
        setFormData(prev => ({
            ...prev,
            addons: selectedIds
        }));
    };

    const handleGenerateBarcode = async () => {
        if (!productDetails?.id) {
            toast.current.show({ severity: 'warn', summary: 'Info', detail: 'Save product before generating barcode', life: 2500 });
            return;
        }
        if (!formData.sku_code) {
            toast.current.show({ severity: 'warn', summary: 'Info', detail: 'SKU code missing', life: 2500 });
            return;
        }
        setBarcodeGenerating(true);
        try {
            const resp = await CustomAxios.post(`products/${productDetails.id}/generate-barcode/`);
            const url = resp?.data?.barcode_image;
            if (url) {
                setBarcodeImageUrl(url);
                setFormData(prev => ({ ...prev, barcode_image: url }));
                toast.current.show({ severity: 'success', summary: 'Generated', detail: 'Barcode generated', life: 2000 });
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'No barcode returned', life: 3000 });
            }
        } catch (err) {
            const msg = err?.response?.data?.error || err?.message || 'Failed to generate barcode';
            toast.current.show({ severity: 'error', summary: 'Error', detail: msg, life: 3000 });
        } finally {
            setBarcodeGenerating(false);
        }
    };

    const handleDownloadBarcode = () => {
        if (!barcodeImageUrl) return;
        const link = document.createElement('a');
        link.href = barcodeImageUrl;
        link.download = `${formData.sku_code || 'barcode'}.webp`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handlePrintBarcode = () => {
        if (!barcodeImageUrl) return;
        const win = window.open('', '_blank');
        if (win) {
            win.document.write(`<img src="${barcodeImageUrl}" style="max-width:100%;"/>`);
            win.document.close();
            win.focus();
            win.print();
            win.close();
        }
    };

const handleOpen = (prefillSku = "", overrides = {}) => {
    setErrors({});
    const role = localStorage.getItem('role');
    const total_hub = JSON.parse(localStorage.getItem('hub')) || [];

    let defaultInventory = [];

    if (role === 'supervisor') {
        if (total_hub.length === 1) {
            defaultInventory = [total_hub[0]];
        } else {
            defaultInventory = []; // supervisor with multiple hubs can choose
        }
    }

    const base = {
        item_name: "",
        item_description: "",
        item_category: "",
        item_criteria: "",
        sku_code: prefillSku || "",
        inventory: defaultInventory,
        images: [],
        image_urls: [],
        item_details: "",
        barcode_image: "",
        product_barcode:"",
        capacitydetails: [{
            item_price: "",
            item_available: true,
            item_capacity: "",
            item_quantity: "",
            item_tax: "",
            item_selling_price: "",
            item_offers_price: 0.00,
            extraPercentage: "",
            capacityValue: "",
            item_special_offer:"",
            unit: "",
            availability_type : "all_time",
            available_from : "",
            available_to : ""
        }]
    };

    dispatch(updateProductDetail({ ...base, ...overrides, sku_code: overrides.sku_code ?? prefillSku ?? "" }));
    dispatch(updateEdit(false));
    dispatch(updateModal(true));
};

    const handleClose = () => {
        setErrors({})
        dispatch(updateModal(false)); 
        dispatch(updateEdit(false))
        setBarcodeImageUrl("");
        dispatch(updateProductDetail({
            item_name: "",
            item_description: "",
            item_category: "",
            item_criteria: "",
            images: [],
            item_details: "",
            // product_group_id: "",
            capacitydetails: [{ 
                item_price: "",
                item_available: true,
                item_capacity: "",
                item_quantity: "",
                item_tax: "",
                item_selling_price: "",
                item_offers_price: 0.00,
                extraPercentage : "",
                availability_type : "all_time",
                available_from : "",
                available_to : ""

            }]
        }));
        setImagePreviews([])
    };


   const handleSaveProducts = async () => {

    Object.keys(formData.capacitydetails || {}).forEach(invId => {
    const caps = formData.capacitydetails[invId];

    if (Array.isArray(caps)) {
        caps.forEach((cap, idx) => {
        if (!cap.extraPercentage || cap.extraPercentage.toString().trim() === "") {
            cap.extraPercentage = "0";
        }
        if (!cap.item_special_offer || cap.item_special_offer.toString().trim() === "") {
            cap.item_special_offer = "0";
        }
        });
    } else {
        console.warn(`Expected array for capacitydetails[${invId}], but got:`, caps);
    }
    });

    const data = new FormData();

    // ✅ Separate File objects from URL strings in images array
    const imageFiles = [];
    const imageUrlsFromImages = [];
    
    if (Array.isArray(formData.images)) {
        formData.images.forEach((item) => {
            if (item instanceof File) {
                imageFiles.push(item);
            } else if (typeof item === 'string' && (item.startsWith('http://') || item.startsWith('https://'))) {
                // Handle case where images array contains URL strings (from VisionProductScanner)
                imageUrlsFromImages.push(item);
            }
        });
    }

    // ✅ Append File objects to FormData
    imageFiles.forEach((file) => {
        data.append('images', file);
    });

    // ✅ Merge image_urls from formData and any URLs found in images array
    const allImageUrls = [
        ...(Array.isArray(formData.image_urls) ? formData.image_urls : []),
        ...imageUrlsFromImages
    ];
    
    // Remove duplicates
    const uniqueImageUrls = [...new Set(allImageUrls)];
    
    // ✅ Include image_urls so backend can use remote URLs when provided
    if (uniqueImageUrls.length > 0) {
        data.append("image_urls", JSON.stringify(uniqueImageUrls));
    }


    // ✅ Flatten capacitydetails to match backend
const flattenedCapacities = [];

Object.entries(formData.capacitydetails || {}).forEach(([inventoryId, items]) => {
    if (Array.isArray(items)) {
        items.forEach((rawItem) => {
            const cleanedItem = {};

            // Clean nested quoted strings (e.g., "\"100\"" => "100")
            Object.entries(rawItem).forEach(([key, value]) => {
                if (typeof value === "string") {
                    try {
                        cleanedItem[key] = JSON.parse(value); // removes extra quotes
                    } catch {
                        cleanedItem[key] = value; // fallback to raw string
                    }
                } else {
                    cleanedItem[key] = value;
                }
            });

            cleanedItem.capacity = `${cleanedItem.capacityValue ?? ''} ${cleanedItem.unit ?? ''}`.trim();
            cleanedItem.item_capacity = cleanedItem.capacity;
            cleanedItem.inventory = parseInt(inventoryId);

            // Strip UI-only fields and legacy availability fields
            delete cleanedItem.availability_type;
            delete cleanedItem.available_from;
            delete cleanedItem.available_to;
            delete cleanedItem.available_from_datetime;
            delete cleanedItem.available_to_datetime;
            delete cleanedItem.repeat_mode;
            delete cleanedItem.repeat_days;
            delete cleanedItem.ui_startDateTime;
            delete cleanedItem.ui_endDateTime;
            delete cleanedItem.ui_daysOfWeek;
            delete cleanedItem.ui_crossesMidnight;


            flattenedCapacities.push(cleanedItem);
        });
    } else {
        console.warn(`Expected array for inventory ${inventoryId}, but got:`, items);
    }
});

    // ✅ Append flattened capacities
    data.append('capacities', JSON.stringify(flattenedCapacities));

    // ✅ Append other fields (excluding images, image_urls, and capacitydetails)
   Object.entries(formData).forEach(([key, value]) => {
    if (key === 'addons' && Array.isArray(value)) {
        value.forEach((addonId) => {
            data.append("addons", addonId);  // append each ID separately
        });
    } else if (key !== 'images' && key !== 'image_urls' && key !== 'capacitydetails') {
        data.append(key, typeof value === 'boolean' ? value.toString() : value);
    }
});

    // ✅ Log FormData content
    // console.log("🧾 FormData Preview:");
    for (let [key, val] of data.entries()) {
        console.log(`keyval ${key}:`, val);
    }

    // ✅ Validation with flattened capacitydetails
    const formDataForValidation = {
        ...formData,
        capacitydetails: flattenedCapacities
    };

    try {
        await validationSchema.validate(formDataForValidation, { abortEarly: false });
        setErrors({});
        setLoading(true);

        // ✅ Make POST request
        await CustomAxios.post(`products/add/`, data);
        toast.current.show({ severity: 'success', summary: 'Success', detail: 'Product Added Successfully', life: 3000 });

        getProducts();
        handleClose();
        setFormData([]);
        dispatch(updateModal(false));
        setLoading(false);
    } catch (validationErrors) {
        setLoading(false);
        if (validationErrors.name === "ValidationError") {
            const formErrors = {};
            validationErrors.inner.forEach((error) => {
                formErrors[error.path] = error.message;
            });
            setErrors(formErrors);
        } else if (validationErrors?.isAxiosError) {
            console.error("Axios error:", validationErrors);
            
            // Handle backend validation errors
            if (validationErrors.response && validationErrors.response.data) {
                const errorData = validationErrors.response.data;
                
                // Handle Django validation errors (array format)
                if (Array.isArray(errorData)) {
                    const cleanMessages = errorData.map(error => {
                        // Handle ErrorDetail objects
                        if (error && typeof error === 'object' && error.string) {
                            return error.string;
                        }
                        // Handle plain strings
                        return String(error);
                    });
                    const errorMessage = cleanMessages.join(', ');
                    toast.current.show({ 
                        severity: 'error', 
                        summary: 'Validation Error', 
                        detail: errorMessage, 
                        life: 5000 
                    });
                }
                // Handle single error message
                else if (typeof errorData === 'string') {
                    toast.current.show({ 
                        severity: 'error', 
                        summary: 'Error', 
                        detail: errorData, 
                        life: 5000 
                    });
                }
                // Handle object with error details
                else if (typeof errorData === 'object') {
                    let errorMessage = errorData.detail || errorData.message || JSON.stringify(errorData);
                    
                    // Handle Django ErrorDetail string format
                    if (typeof errorMessage === 'string' && errorMessage.includes('ErrorDetail')) {
                        // Extract the actual message from ErrorDetail string format
                        // Handles formats like: [ErrorDetail(string='message', code='invalid')]
                        const match = errorMessage.match(/string='([^']+)'/);
                        if (match) {
                            errorMessage = match[1];
                        } else {
                            // Fallback: try to extract any quoted string
                            const fallbackMatch = errorMessage.match(/'([^']+)'/);
                            if (fallbackMatch) {
                                errorMessage = fallbackMatch[1];
                            }
                        }
                    }
                    
                    toast.current.show({ 
                        severity: 'error', 
                        summary: 'Error', 
                        detail: errorMessage, 
                        life: 5000 
                    });
                }
                else {
                    toast.current.show({ 
                        severity: 'error', 
                        summary: 'Save failed', 
                        detail: 'Something went wrong.', 
                        life: 3000 
                    });
                }
            } else {
                toast.current.show({ 
                    severity: 'error', 
                    summary: 'Save failed', 
                    detail: 'Something went wrong.', 
                    life: 3000 
                });
            }
        } else {
            console.error("Unexpected error:", validationErrors);
            toast.current.show({ 
                severity: 'error', 
                summary: 'Error', 
                detail: validationErrors.message || 'Something went wrong.', 
                life: 3000 
            });
        }
    }
};


    const countryOptionTemplate = (option) => {
    // console.log('options--------->>', option);

    const capacityValues = option.capacitydetails ? Object.values(option.capacitydetails) : [];
    const capacityNames = capacityValues.map(cap => cap.name).filter(Boolean).join(", ");

    return (
        <Box sx={{ display: "flex", gap: "10px" }}>
            <Box
                component="img"
                alt={option.item_name}
                src={option.image}
                sx={{ width: "30px", height: "30px", objectFit: "cover" }}
            />
            <Box>
                {option.item_name}{" "}
                {capacityNames && <span style={{ color: "gray" }}>({capacityNames})</span>}
            </Box>
        </Box>
    );
};

const selectedCountryTemplate = (option, props) => {
    // console.log('options------22--->>', option);

    if (option) {
        const capacityValues = option.capacitydetails ? Object.values(option.capacitydetails) : [];
        const capacityNames = capacityValues.map(cap => cap.name).filter(Boolean).join(", ");

        return (
            <Box sx={{ display: "flex", gap: "10px" }}>
                <Box
                    component="img"
                    alt={option.item_name}
                    src={option.image}
                    sx={{ width: "16px", height: "16px", objectFit: "cover" }}
                />
                <Box>
                    {option.item_name}{" "}
                    {capacityNames && <span style={{ color: "gray" }}>({capacityNames})</span>}
                </Box>
            </Box>
        );
    }

    return <span>{props.placeholder}</span>;
};

    //console.log(edit)
    const handleUpdateProducts = async (id) => {

    // ✅ Step 1: Deep clone the formData to avoid read-only mutation errors
    // console.log('all data====',formData)
    const updatedFormData = { ...formData };

        updatedFormData.capacitydetails = JSON.parse(JSON.stringify(formData.capacitydetails));

    Object.keys(updatedFormData.capacitydetails).forEach(invId => {
      updatedFormData.capacitydetails[invId].forEach(cap => {
        if (!cap.extraPercentage || cap.extraPercentage.toString().trim() === "") {
          cap.extraPercentage = "0";
        }
        if (!cap.item_special_offer || cap.item_special_offer.toString().trim() === "") {
          cap.item_special_offer = "0";
        }
      });
    });

        const data = new FormData();
        //console.log("inside updateModal",formData)

        // Image validation removed for update per request
    
for (let [key, value] of Object.entries(updatedFormData)) {
    if (Array.isArray(value)) {
        if (key === 'images') {
            // ✅ Separate File objects from URL strings
            const imageFiles = [];
            const imageUrlsFromImages = [];
            
            value.forEach((item) => {
                if (item instanceof File) {
                    imageFiles.push(item);
                    // console.log(`${key}:`, item);
                } else if (typeof item === 'string' && (item.startsWith('http://') || item.startsWith('https://'))) {
                    // Handle case where images array contains URL strings (from VisionProductScanner)
                    imageUrlsFromImages.push(item);
                } else {
                    console.error(`Expected a File object or URL string, but got:`, item);
                }
            });
            
            // Append File objects
            imageFiles.forEach((file) => {
                data.append(key, file);
            });
            
            // Merge with existing image_urls if any
            if (imageUrlsFromImages.length > 0) {
                const existingUrls = Array.isArray(updatedFormData.image_urls) ? updatedFormData.image_urls : [];
                const allUrls = [...existingUrls, ...imageUrlsFromImages];
                const uniqueUrls = [...new Set(allUrls)];
                updatedFormData.image_urls = uniqueUrls;
            }
        }
        else if (key === 'addons') {
            value.forEach((addonId) => {
                data.append("addons", addonId);
            });
        }
    
    } else if (key === 'capacitydetails') {
    const flattened = [];

    // Flatten the grouped inventory-wise array into a flat list
    Object.entries(value).forEach(([inventoryId, items]) => {
    items.forEach((entry) => {
        const cleaned = {
            ...entry,
            inventory: parseInt(inventoryId),
            capacity: `${entry.capacityValue} ${entry.unit}`.trim(),
            item_capacity: `${entry.capacityValue} ${entry.unit}`.trim()
        };

        // Strip UI-only fields
        delete cleaned.ui_startDateTime;
        delete cleaned.ui_endDateTime;
        delete cleaned.ui_daysOfWeek;
        delete cleaned.ui_crossesMidnight;

        flattened.push(cleaned);
    });
});


    // ✅ Append the corrected flat array
    data.append('capacitydetails', JSON.stringify(flattened));

    // ✅ Update for validation check too
    updatedFormData.capacitydetails = flattened;

    }
    else {
        // ✅ Handle image_urls separately to avoid duplicate appends
        if (key === 'image_urls') {
            if (Array.isArray(value) && value.length > 0) {
                data.append('image_urls', JSON.stringify(value));
            }
        } else {
            // console.log('update adonnn------------------',key,value)
            data.append(key, typeof value === 'boolean' ? value.toString() : value);
        }
    }
}


    // ✅ Optional: force image replacement
    data.append('replace_images', 'true');
    data.append('inventory_id', selectedHub);  


// ✅ Log FormData contents
// console.log("🧾 Final FormData:");
for (let [key, val] of data.entries()) {
    if (key === 'capacities') {
        try {
            const parsed = JSON.parse(val);
            console.log(`${key}:`, parsed); // ✅ full object/array
        } catch {
            console.log(`${key}:`, val); // fallback
        }
    } else if (key === 'images') {
        console.log(`${key}:`, val.name); // just show image filename
    } else {
        console.log(`${key}:`, val);
    }
}
        try{
            setLoading(true);
            await validationSchema.validate(updatedFormData, { abortEarly: false });
            setErrors({});
        const response = await CustomAxios.put(`products/update/${id}/`, data);   
            toast.current.show({ severity: 'success', summary: 'Success', detail: 'Product updates Successfully', life: 3000 });
            getProducts()
            handleClose()
            setFormData([])
            dispatch(updateModal(false))
            setLoading(false)
            
        }
        catch (validationErrors) {
            setLoading(false);
            if (validationErrors.name === "ValidationError") {
              const formErrors = {};
              validationErrors.inner.forEach((error) => {
                formErrors[error.path] = error.message;
              });
              setErrors(formErrors);
              setLoading(false);
            } else if (validationErrors?.isAxiosError) {
              console.error("Axios error:", validationErrors);
              
              // Handle backend validation errors
              if (validationErrors.response && validationErrors.response.data) {
                const errorData = validationErrors.response.data;
                
                // Handle Django validation errors (array format)
                if (Array.isArray(errorData)) {
                    const cleanMessages = errorData.map(error => {
                        // Handle ErrorDetail objects
                        if (error && typeof error === 'object' && error.string) {
                            return error.string;
                        }
                        // Handle plain strings
                        return String(error);
                    });
                    const errorMessage = cleanMessages.join(', ');
                    toast.current.show({ 
                        severity: 'error', 
                        summary: 'Validation Error', 
                        detail: errorMessage, 
                        life: 5000 
                    });
                }
                // Handle single error message
                else if (typeof errorData === 'string') {
                  toast.current.show({ 
                    severity: 'error', 
                    summary: 'Error', 
                    detail: errorData, 
                    life: 5000 
                  });
                }
                // Handle object with error details
                else if (typeof errorData === 'object') {
                    let errorMessage = errorData.detail || errorData.message || JSON.stringify(errorData);
                    
                    // Handle Django ErrorDetail string format
                    if (typeof errorMessage === 'string' && errorMessage.includes('ErrorDetail')) {
                        // Extract the actual message from ErrorDetail string format
                        // Handles formats like: [ErrorDetail(string='message', code='invalid')]
                        const match = errorMessage.match(/string='([^']+)'/);
                        if (match) {
                            errorMessage = match[1];
                        } else {
                            // Fallback: try to extract any quoted string
                            const fallbackMatch = errorMessage.match(/'([^']+)'/);
                            if (fallbackMatch) {
                                errorMessage = fallbackMatch[1];
                            }
                        }
                    }
                    
                    toast.current.show({ 
                        severity: 'error', 
                        summary: 'Error', 
                        detail: errorMessage, 
                        life: 5000 
                    });
                }
                else {
                  toast.current.show({ 
                    severity: 'error', 
                    summary: 'Update failed', 
                    detail: 'Something went wrong.', 
                    life: 3000 
                  });
                }
              } else {
                toast.current.show({ 
                  severity: 'error', 
                  summary: 'Update failed', 
                  detail: 'Something went wrong.', 
                  life: 3000 
                });
              }
            } else {
              console.error("Unexpected error:", validationErrors);
              toast.current.show({ 
                severity: 'error', 
                summary: 'Error', 
                detail: validationErrors.message || 'Something went wrong.', 
                life: 3000 
              });
            }
          }
    }

    // console.log(formData)
    // console.log("images-------------",imagePreviews)

    const validationSchema = Yup.object().shape({
        item_name: Yup.string().required("Name is required"),
        item_description: Yup.string().required("Description is required"),
        item_details: Yup.string().required("Details is required"),
        item_category: Yup.string().required("Category is required"),
        item_criteria: Yup.string().required("Criteria is required"),
        //product_barcode: Yup.string().required("Barcode is required"),
        capacitydetails: Yup.array().of(
            Yup.object().shape({
                //   item_capacity: Yup.string()
                //   .required("capacity is required"),
                  item_price: Yup.string()
                  .matches(/^\d+(\.\d{1,2})?$/, "Price must contain only digits")
                  .required("Price is required"),
                  item_tax: Yup.string()
                  .matches(/^\d+(\.\d{1,2})?$/, "Tax must contain only digits")
                  .required("Tax is required"),
                item_offers_price: Yup.string()
                .matches(/^\d+(\.\d{1,2})?$/, "Offers price must contain only digits")
                .required("Offers is required"),
                item_selling_price: Yup.string()
                .matches(/^\d+(\.\d{1,2})?$/, "Selling price must contain only digits")
                .required("Selling is required"),
                capacityValue: Yup.string()
                .required("capacityValue is required"),
                unit: Yup.string()
                .required("unit is required"),
            })
        ),
      });
      console.log(errors)

      // Availability/time logic removed

        const handleCloseCategoryModal = () => {
            setErrors({})
            dispatch(updateModal(false)); 
            dispatch(updateEdit(false))
            dispatch(updateCategoryDetails({
                category_name: "",
                invetory_list:[],
                category_image: []
            }))
            setImagePreviews([])
        };

        const validateCapacityDateRanges = () => {
            // Availability validation removed
            return {};
        };

        const handleSaveCampaigns = async () => {
            const data = new FormData();
        
            for (const [key, value] of Object.entries(formData)) {
                if (Array.isArray(value)) {
                       if (key === "category_image") {
                        //    console.log("we are here")
                           value.forEach((file) => {
                               if (file instanceof File) {
                                //    console.log("we are here 2")
                                   data.append(key, file);
                               } else {
                                   console.error(`Expected a File object, but received:`, file);
                               }
                           });
                       }
                       else{
                           data.append(key, JSON.stringify(value));
                       }
                   } else {
                       data.append(key, value);
                   }
               }
        
            try {
                const capErrors = validateCapacityDateRanges();
                if (Object.keys(capErrors).length) {
                    setErrors((prev) => ({ ...prev, capacitydetails: capErrors }));
                    return;
                }
                await categoryValidationSchema.validate(formData, { abortEarly: false });
                setErrors({});
        
                if (data) {
                    setLoading(true);
        
                    await CustomAxios.post(`category_create/`, data)
                        .then((res) => {
                            toast.current.show({
                                severity: 'success',
                                summary: 'Success',
                                detail: 'Category Added Successfully',
                                life: 3000,
                            });
                            getCategory();
                            getInventory();
                            handleCloseCategoryModal();
                            setFormData([]);
                            dispatch(updateModal(false));
                            setLoading(false);
                        });
                }
            } catch (error) {
                if (error.name === "ValidationError") {
                    const formErrors = {};
                    error.inner.forEach((err) => {
                        formErrors[err.path] = err.message;
                    });
                    setErrors(formErrors);
                    setLoading(false);
                } 
                // Handle duplicate description error from the backend
                else if (
                    error.response &&
                    error.response.data
                ) {
                    setErrors({ category_name: "Category Name already exists" });
                    setLoading(false); // Ensure loading is stopped for this error
                } else {
                    console.error("Error while saving campaign:", error);
                    setLoading(false); // Stop loading on other errors as well
                }
                setLoading(false); // Stop loading on validation error
            }
        };

        const handleUpdateCampaigns = async (id) => {
            const data = new FormData();
            // console.log(data)
            for (const [key, value] of Object.entries(formData)) {
             if (Array.isArray(value)) {
                    if (key === "category_image") {
                        // console.log("we are here")
                        value.forEach((file) => {
                            if (file instanceof File) {
                                // console.log("we are here 2")
                                data.append(key, file);
                            } else {
                                console.error(`Expected a File object, but received:`, file);
                            }
                        });
                    }
                    else{
                        data.append(key, value);
                    }
                } else {
                    data.append(key, value);
                }
            }
            // console.log(data)
        
            try {
                const capErrors = validateCapacityDateRanges();
                if (Object.keys(capErrors).length) {
                    setErrors((prev) => ({ ...prev, capacitydetails: capErrors }));
                    setLoading(false);
                    return;
                }
                setLoading(true);
                await categoryValidationSchema.validate(formData, { abortEarly: false });
                setErrors({});
        
                await CustomAxios.put(`category_update/${id}/`, data)
                    .then((res) => {
                        toast.current.show({
                            severity: 'success',
                            summary: 'Success',
                            detail: 'Category updated successfully',
                            life: 3000,
                        });
                        getCategory();
                        getInventory();
                        handleCloseCategoryModal();
                        setFormData([]);
                        dispatch(updateModal(false));
                        setLoading(false);
                    });
            } catch (error) {
                if (error.name === "ValidationError") {
                    const formErrors = {};
                    error.inner.forEach((err) => {
                        formErrors[err.path] = err.message;
                    });
                    setErrors(formErrors);
                    setLoading(false);
                } 
                // Handle duplicate description error from the backend
                else if (
                    error.response &&
                    error.response.data
                ) {
                    setErrors({ category_name: "Category Name already exists" });
                    setLoading(false); // Ensure loading is stopped for this error
                } else {
                    console.error("Error while updating campaign:", error);
                    setLoading(false); // Stop loading on other errors as well
                }
            }
        };

        const categoryValidationSchema = Yup.object().shape({
            category_name: Yup.string().required("Category Name is required"),
            invetory_list: Yup.array().required("Inventory List is required"),
            category_image: Yup.array()
            .of(
                Yup.mixed().test("file-or-url", "Each item must be a valid file or URL", (value) => {
                    return typeof value === "string" || value instanceof File;
                })
            )
            .min(1, "At least one image is required")
            .required("Images are required")
        });



    return (
        <Box sx={{ display: "flex", flexDirection: "column", width: "100%" ,padding:"30px"}}>
            <Toast ref={toast} />
            <ToastContainer position="top-right" autoClose={1000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="light" transition="Bounce" />
            <input
                type="file"
                accept=".xlsx"
                ref={bulkFileInputRef}
                onChange={handleBulkFileChange}
                style={{ display: "none" }}
            />
            <Box sx={{ display: "flex", flexDirection: "column", gap: "8px",marginBottom:"20px" }}>
                <Typography sx={{ fontSize: "16px", fontWeight: "700", lineHeight: "24px" }}>Product Management</Typography>
                <Typography sx={{ fontSize: "14px", fontWeight: "500", lineHeight: "22px" }}>Product Details</Typography>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%",marginBottom:"30px" }}>
                <Box sx={{ position: "relative" }}>
                    <InputBase sx={{ backgroundColor: "white", height: "32px", width: "100%", maxWidth: "268px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px 5px 40px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} onChange={(e) => dispatch(updatesearchProduct(e.target.value))} placeholder="Search item name" />
                    <SearchIcon sx={{ position: "absolute", left: "12px", top: "5px", width: "20px", height: "20px" }} />
                </Box>
                {canManageProducts && (
                    <Box sx={{ display: "flex", gap: 1 }}>
                    <Button variant="contained" onClick={() => handleOpen()} sx={{ textTransform: "none" }}> Add Product</Button>
                    <Button
                        variant="outlined"
                        startIcon={<QrCodeScannerIcon />}
                        onClick={openScanAdd}
                        disabled={scanPermissionLoading}
                        sx={{ textTransform: "none" }}
                    >
                        {scanPermissionLoading ? "Requesting camera..." : "Scan-add"}
                    </Button>
                    <Button
                        variant="outlined"
                        startIcon={<QrCodeScannerIcon />}
                        onClick={openBulkScanDialog}
                        disabled={bulkScanPermissionLoading}
                        sx={{ textTransform: "none" }}
                    >
                        {bulkScanPermissionLoading ? "Loading..." : "Bulk Scan & Add"}
                    </Button>
                        <Button
                            variant="outlined"
                            startIcon={<UploadFileIcon />}
                            onClick={openBulkUpload}
                            sx={{ textTransform: "none" }}
                        >
                            Bulk Products Upload
                        </Button>
                    </Box>
                )}
            </Box>
            <ProductTable />
            <Modal
                open={bulkDialogOpen}
                onClose={closeBulkUpload}
                aria-labelledby="bulk-upload"
            >
                <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 480, backgroundColor: 'white', p: 3, display: "flex", flexDirection: "column", gap: 2, borderRadius: "8px" }}>
                    <Typography id="bulk-upload" sx={{ fontSize: "16px", fontWeight: 700 }}>Bulk Products Upload</Typography>
                    <Box sx={{ display: "flex", gap: 1 }}>
                        <Button variant="outlined" startIcon={<DownloadIcon />} onClick={handleDownloadBulkSample} sx={{ textTransform: "none" }}>
                            Download Sample
                        </Button>
                        <LoadingButton
                            variant="contained"
                            startIcon={<UploadFileIcon />}
                            loading={bulkUploading}
                            onClick={triggerBulkFilePicker}
                            sx={{ textTransform: "none" }}
                        >
                            Upload (.xlsx)
                        </LoadingButton>
                    </Box>
                    {bulkErrors?.length > 0 && (
                        <Box sx={{ maxHeight: 200, overflowY: "auto", p: 1, border: "1px solid", borderColor: "secondary.border", borderRadius: "6px", backgroundColor: "#fafafa" }}>
                            <Typography sx={{ fontWeight: 600, mb: 1 }}>Failed rows</Typography>
                            {bulkErrors.map((err, idx) => (
                                <Typography key={idx} sx={{ fontSize: "12px", color: "error.main" }}>
                                    Row {err?.row}: {err?.message}
                                </Typography>
                            ))}
                        </Box>
                    )}
                </Box>
            </Modal>
            <Modal open={scanDialogOpen} onClose={closeScanAdd}>
                <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 540, maxWidth: "90%", backgroundColor: 'white', p: 3, display: "flex", flexDirection: "column", gap: 2, borderRadius: "8px" }}>
                    <Typography sx={{ fontSize: "16px", fontWeight: 700 }}>Scan & Add Product</Typography>
                    
                    {/* Mode Selection Tabs */}
                    <Box sx={{ display: "flex", gap: 1, borderBottom: "1px solid #e0e0e0", pb: 1 }}>
                        <Button
                            variant={scanMode === "barcode" ? "contained" : "outlined"}
                            startIcon={<QrCodeScannerIcon />}
                            onClick={() => { setScanMode("barcode"); setScanError(""); }}
                            sx={{ textTransform: "none", flex: 1 }}
                        >
                            Scan Barcode
                        </Button>
                        <Button
                            variant={scanMode === "vision" ? "contained" : "outlined"}
                            startIcon={<CameraAltIcon />}
                            onClick={() => { setScanMode("vision"); setScanError(""); }}
                            sx={{ textTransform: "none", flex: 1 }}
                        >
                            Identify Product
                        </Button>
                    </Box>

                    {scanMode === "barcode" ? (
                        <>
                            <Typography sx={{ fontSize: "14px", color: "text.secondary" }}>
                                Use camera to scan a barcode/QR. If camera is unavailable, enter the code manually.
                            </Typography>
                            <BarcodeScanner onDetected={handleScanDetected} onError={handleScanError} active={scanDialogOpen && scanMode === "barcode"} />
                            <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="Enter code manually"
                                    value={scannedCode}
                                    onChange={(e) => setScannedCode(e.target.value)}
                                    disabled={scanLookupLoading}
                                />
                                <Button variant="contained" onClick={handleManualScanSubmit} disabled={scanLookupLoading} sx={{ textTransform: "none", whiteSpace: "nowrap" }}>
                                    {scanLookupLoading ? "Fetching..." : "Use code"}
                                </Button>
                            </Box>
                        </>
                    ) : (
                        <>
                            <Typography sx={{ fontSize: "14px", color: "text.secondary" }}>
                                Point camera at the product to identify it using AI. Works best with clear product labels.
                            </Typography>
                            <VisionProductScanner 
                                active={scanDialogOpen && scanMode === "vision"}
                                onDetected={handleVisionDetected}
                                onError={handleVisionError}
                                onLoading={setVisionLoading}
                            />
                            {visionLoading && (
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                    <CircularProgress size={20} />
                                    <Typography sx={{ fontSize: "14px", color: "text.secondary" }}>
                                        Analyzing product...
                                    </Typography>
                                </Box>
                            )}
                        </>
                    )}
                    
                    {scanError && (
                        <Typography color="error" variant="body2">
                            {scanError}
                        </Typography>
                    )}
                </Box>
            </Modal>
            <Modal
                open={modal}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                sx={{ zIndex: 1000 }}
            >
                <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '100%', maxWidth: "1500px", height: "697px", backgroundColor: 'white', }}>
                    <Box sx={{ height: "46px important", padding: "12px 24px", backgroundColor: "#EEEEEE", display: "flex", alignItems: "center" }}>
                        <Typography sx={{ fontSize: "14", fontWeight: "500", lineHeight: "22px" }}> {edit ? "Edit Product" : "Add Product"}</Typography>
                    </Box>
                    <Box >
                        <Box sx={{ padding: "24px", display: "flex", gap: "16px", flexDirection: "column", height: "590px", overflowY: "auto" }}>
                            <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Inventory List</Typography>
                                {(() => {
                                    // console.log('[Autocomplete Render] ===== INVENTORY AUTOCOMPLETE RENDER =====');
                                    // console.log('[Autocomplete Render] filteredInventory:', filteredInventory);
                                    // console.log('[Autocomplete Render] filteredInventory length:', filteredInventory?.length);
                                    // console.log('[Autocomplete Render] selectedInventoryOptions:', selectedInventoryOptions);
                                    // console.log('[Autocomplete Render] selectedInventoryOptions length:', selectedInventoryOptions?.length);
                                    // console.log('[Autocomplete Render] formData.inventory:', formData.inventory);
                                    if (selectedInventoryOptions && selectedInventoryOptions.length > 0) {
                                        selectedInventoryOptions.forEach((opt, idx) => {
                                            console.log(`[Autocomplete Render] Selected option ${idx}:`, opt);
                                            console.log(`[Autocomplete Render] Option ${idx} name:`, opt?.name);
                                            console.log(`[Autocomplete Render] Option ${idx} value:`, opt?.value);
                                        });
                                    }
                                    // console.log('[Autocomplete Render] ===== END AUTOCOMPLETE DEBUG =====');
                                    return null;
                                })()}
                                <Autocomplete
                                    multiple
                                    options={filteredInventory || []}
                                    value={selectedInventoryOptions}
                                    onChange={handleInventorySelect}
                                    getOptionLabel={(option) => {
                                        const label = option?.name || "";
                                        // console.log('[Autocomplete getOptionLabel] option:', option, 'label:', label);
                                        return label;
                                    }}
                                    isOptionEqualToValue={(opt, val) => {
                                        const isEqual = opt?.value === val?.value;
                                        // console.log('[Autocomplete isOptionEqualToValue] opt:', opt, 'val:', val, 'isEqual:', isEqual);
                                        return isEqual;
                                    }}
                                    getOptionDisabled={(opt) => !!opt?.disabled}
                                    renderInput={(params) => (
                                        <TextField {...params} size="small" placeholder="Select Inventory" />
                                    )}
                                    disableCloseOnSelect
                                    sx={{ width: "100%" }}
                                    disabled={localStorage.getItem('role') === 'supervisor' && JSON.parse(localStorage.getItem('hub')).length === 1}
                                />
                                {errors.inventory && <Typography style={{ color: "red", fontSize: "12PX", fontWeight: "400", lineHeight: "22px" }}>{errors.inventory}</Typography>}
                            </Box>
                            <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Name</Typography>
                                <InputBase value={formData.item_name} sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} placeholder="Enter product name" name="item_name" onChange={handleChange} />
                                {errors.item_name && <Typography style={{ color: "red" ,  fontSize: "12PX", fontWeight: "400", lineHeight: "22px"  }}>{errors.item_name}</Typography>}
                            </Box>
                            <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>SKU Code</Typography>
                                <InputBase value={formData.sku_code || "Auto-generated"} disabled sx={{ backgroundColor: "#f5f5f5", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} />
                                <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
                                    <Button variant="contained" size="small" disabled={barcodeGenerating || !productDetails?.id} onClick={handleGenerateBarcode}>
                                        {barcodeGenerating ? "Generating..." : "Generate Barcode"}
                                    </Button>
                                    {barcodeImageUrl && (
                                        <>
                                            <Box component="img" src={barcodeImageUrl} alt="barcode" sx={{ height: 180, width: 280, objectFit: "contain", background: "#fff", border: "1px solid #e0e0e0", borderRadius: "4px", p: 1 }} />
                                            <Button variant="outlined" size="small" onClick={handleDownloadBarcode}>Download</Button>
                                            <Button variant="outlined" size="small" onClick={handlePrintBarcode}>Print</Button>
                                        </>
                                    )}
                                </Box>
                            </Box>
                            <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Product Barcode</Typography>
                                <InputBase value={formData.product_barcode} sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} placeholder="Enter product barcode" name="product_barcode" onChange={handleChange} />
                                {errors.product_barcode && <Typography style={{ color: "red" ,  fontSize: "12PX", fontWeight: "400", lineHeight: "22px"  }}>{errors.product_barcode}</Typography>}
                            </Box>
                            <Box sx={{ width: "100%", display: "flex", gap: "16px" }}>
                                <Box sx={{ width: "50%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                    <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }} name="item_category">category</Typography>
                                <Autocomplete
                                    options={category || []}
                                    value={selectedCategoryOption}
                                    onChange={handleCategorySelect}
                                    getOptionLabel={(option) => option?.name || ""}
                                    isOptionEqualToValue={(opt, val) => opt?.value === val?.value}
                                    renderInput={(params) => <TextField {...params} size="small" placeholder="Select category" />}
                                />
                                {errors.item_category && <Typography style={{ color: "red" ,  fontSize: "12PX", fontWeight: "400", lineHeight: "22px"  }}>{errors.item_category}</Typography>}

                                </Box>
                                <Box sx={{ width: "50%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                    <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }} name="item_sub_category">sub category</Typography>
                                    <Autocomplete
                                        options={subCategory || []}
                                        value={selectedSubCategoryOption}
                                        onChange={handleSubCategorySelect}
                                        getOptionLabel={(option) => option?.name || ""}
                                        isOptionEqualToValue={(opt, val) => opt?.value === val?.value}
                                        renderInput={(params) => <TextField {...params} size="small" placeholder="Select sub category" />}
                                        disabled={formData.item_category === "Addon"}
                                    />

                                </Box>
                                <Box sx={{ width: "50%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                    <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }} >criteria</Typography>
                                    <Autocomplete
                                        options={criteria || []}
                                        value={selectedCriteriaOption}
                                        onChange={handleCriteriaSelect}
                                        getOptionLabel={(option) => option?.name || ""}
                                        isOptionEqualToValue={(opt, val) => opt?.value === val?.value || opt?.name === val?.name}
                                        renderInput={(params) => <TextField {...params} size="small" placeholder="Select criteria" />}
                                    />
                                {errors.item_criteria && <Typography style={{ color: "red" ,  fontSize: "12PX", fontWeight: "400", lineHeight: "22px"  }}>{errors.item_criteria}</Typography>}

                                </Box>
                                <Box sx={{ width: "50%", display: "flex", flexDirection: "row",marginTop:"25px", gap: "10px", alignItems:"center", justifyContent:"center" }}>
                                    <Checkbox onChange={handleChange} checked={formData.shinos_choice===true?true:false} name="shinos_choice" disabled={formData.item_category === "Addon"}/>
                                    <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }} >Shino's Special</Typography>
                                </Box>
                                <Box sx={{ width: "50%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                    <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Add On</Typography>
                                    <Autocomplete
                                        multiple
                                        options={products || []}
                                        value={selectedAddonsOptions}
                                        onChange={handleAddonsSelect}
                                        getOptionLabel={(option) => option?.item_name || ""}
                                        isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
                                        renderInput={(params) => <TextField {...params} size="small" placeholder="Select Product" />}
                                        disabled={formData.item_category !== "food"}
                                        filterSelectedOptions
                                    />
                                </Box>
                            </Box>
                            <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Description</Typography>
                                <InputBase value={formData.item_description} sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} placeholder="Enter product description" name="item_description" onChange={handleChange} />
                                {errors.item_description && <Typography style={{ color: "red" ,  fontSize: "12PX", fontWeight: "400", lineHeight: "22px"  }}>{errors.item_description}</Typography>}
                            </Box>
                            <Editor style={{ height: '135px' }} name="item_details" value={formData.item_details} onTextChange={handleChange} />
                            {errors.item_details && <Typography style={{ color: "red" ,  fontSize: "12PX", fontWeight: "400", lineHeight: "22px"  }}>{errors.item_details}</Typography>}
                            {formData?.inventory?.map((invId) => (
                                <Box key={invId} sx={{ border: '1px solid #ccc', borderRadius: '8px', padding: '16px', marginBottom: '16px' }}>
                                    <Typography sx={{ fontSize: "16px", fontWeight: "600", marginBottom: "8px" }}>
                                        Inventory: {
                                                        filteredInventory.find(item => item.value === invId)?.name || `ID: ${invId}`
                                                        }
                                    </Typography>

                                    {Array.isArray(formData.capacitydetails?.[invId]) &&
                                        formData.capacitydetails[invId].map((capacityDetail, index) => (
                                            <Box key={index} sx={{ width: "100%", display: "flex", gap: "16px", alignItems: "flex-end", marginBottom: "10px" }}>
                                                
                                                <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                                <Typography sx={{ fontSize: "14px", fontWeight: 400, lineHeight: "22px" }}>Capacity</Typography>               
                                                <Box sx={{ display: "flex", gap: "5px" }}>
                                                    <InputBase
                                                    value={capacityDetail.capacityValue}
                                                    name="capacityValue"
                                                    onChange={(e) => handleCapacityChange(invId, index, e)}
                                                    sx={{
                                                        backgroundColor: "white", width: "100px", height: "32px", borderRadius: "2px", border: "1px solid",
                                                        borderColor: errors[`capacitydetails[${index}].capacityValue`] ? "red" : "secondary.border",
                                                        padding: "5px 12px",
                                                    }}
                                                    placeholder="Add Capacity"
                                                    />
                                                    <Autocomplete
                                                        options={capacity || []}
                                                        value={capacity.find(opt => opt.value === capacityDetail.unit) || null}
                                                        onChange={(_e, value) => handleCapacityChange(invId, index, { target: { name: "unit", value: value?.value || "" } })}
                                                        getOptionLabel={(option) => option?.name || ""}
                                                        isOptionEqualToValue={(opt, val) => opt?.value === val?.value}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                size="small"
                                                    placeholder="Select Unit"
                                                                sx={{
                                                                    width: "120px",
                                                                    "& .MuiOutlinedInput-notchedOutline": {
                                                                        borderColor: errors[`capacitydetails[${index}].unit`] ? "red" : undefined
                                                                    }
                                                                }}
                                                            />
                                                        )}
                                                        sx={{ width: "120px" }}
                                                    />
                                                </Box>
                                                </Box>

                                                <Box sx={{ width: "30%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                                    <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Availability</Typography>
                                                    <Autocomplete
                                                        options={availability || []}
                                                        value={availability.find(opt => opt.value === capacityDetail.item_available) || null}
                                                        onChange={(_e, value) => handleCapacityChange(invId, index, { target: { name: "item_available", value: value?.value ?? true } })}
                                                        getOptionLabel={(option) => option?.name || ""}
                                                        isOptionEqualToValue={(opt, val) => opt?.value === val?.value}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                size="small"
                                                                placeholder="Select Availability"
                                                                sx={{ width: "160px" }}
                                                            />
                                                        )}
                                                        sx={{ width: "160px" }}
                                                    />
                                                </Box>

                                                <Box sx={{ width: "50%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                                    <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Price</Typography>
                                                    <InputBase value={capacityDetail.item_price} name="item_price" sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor:  errors[`capacitydetails[${index}].item_price`] ? 'red' :"secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} placeholder="Enter Product price"  onChange={(e) => handleCapacityChange(invId, index, e)} />
                                                </Box>

                                                <Box sx={{ width: "50%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                                    <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Offer Price</Typography>
                                                    <InputBase value={capacityDetail.item_offers_price} name="item_offers_price" sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: errors[`capacitydetails[${index}].item_offers_price`] ? 'red' :"secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} placeholder="Enter Product offer price"  onChange={(e) => handleCapacityChange(invId, index, e)} />
                                                </Box>

                                                <Box sx={{ width: "50%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                                    <Typography sx={{ fontSize: "14px", fontWeight: "400", lineHeight: "22px" }}>Margin</Typography>
                                                    <InputBase 
                                                        value={capacityDetail.extraPercentage ?? '0'}
                                                        name={`extra_percentage_${index}`} 
                                                        sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} 
                                                        placeholder="Enter Selling Percentage" 
                                                        onChange={(e) => handleExtraPercentageChange(invId, index, e.target.value)}
                                                        onBlur={() => {
                                                        if (capacityDetail.extraPercentage === '') {
                                                            handleExtraPercentageChange(index, '0');
                                                        }
                                                        }}
                                                    />
                                                </Box>
                                                <Box sx={{ width: "50%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                                    <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Selling Price</Typography>
                                                    <InputBase value={capacityDetail.item_selling_price} name="item_selling_price" sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: errors[`capacitydetails[${index}].item_selling_price`] ? 'red' :"secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} placeholder="Enter Product selling price" onChange={(e) => handleCapacityChange(invId, index, e)} />
                                                </Box>
                                                <Box sx={{ width: "50%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                                    <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Tax %</Typography>
                                                    <InputBase value={capacityDetail.item_tax} name="item_tax" sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: errors[`capacitydetails[${index}].item_tax`] ? 'red' :"secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} placeholder="Enter Product Tax %" onChange={(e) => handleCapacityChange(invId, index, e)} />
                                                </Box>

                                                <Box 
                                                    sx={{
                                                        width: "50%", 
                                                        display: "flex", 
                                                        flexDirection: "column",
                                                         gap: "10px",
                                                     }}
                                                     >
                                                    <Typography
                                                        sx={{
                                                        fontSize: "14px",
                                                        fontWeight: "400",
                                                        lineHeight: "22px",
                                                        }}
                                                    >
                                                        Special Offer
                                                    </Typography>
                                                        <InputBase
                                                        value={capacityDetail.item_special_offer}
                                                        name="item_special_offer"
                                                        sx={{
                                                        backgroundColor: "white",
                                                        width: "100%",
                                                        height: "32px",
                                                        borderRadius: "2px",
                                                        border: "1px solid",
                                                        borderColor: errors[`capacitydetails[${index}].item_special_offer`]
                                                            ? "red"
                                                            : "secondary.border",
                                                        padding: "5px 12px",
                                                        fontSize: "14px",
                                                        fontWeight: "400",
                                                        lineHeight: "22px",
                                                        color: "black",
                                                        }}
                                                        placeholder="Enter Product Special Offer"
                                                        type="text"
                                                        onChange={(e) => {
                                                            const numericValue = e.target.value.replace(/[^0-9]/g, "");
                                                            handleCapacityChange(invId, index, { target: { name: e.target.name, value: numericValue } });
                                                        }}
                                                        endAdornment={
                                                        <InputAdornment position="end" sx={{ fontSize: "14px", fontWeight: "400", color: "black" }}>
                                                            % off
                                                        </InputAdornment>
                                                        }
                                                    />
                                                </Box>
                                           
                                        
                                            {/* Availability/time modal removed */}
                                                <Tooltip title="Remove" arrow>
                                                    <IconButton type="button" onClick={() => handleRemoveCapacity(invId, index)}>
                                                        <RemoveCircleOutlineOutlinedIcon/>
                                                    </IconButton>
                                                </Tooltip>
                                            </Box>
                                        ))}

                                    <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
                                        <Button variant="outlined" onClick={() => handleAddCapacity(invId)}>
                                            Add Capacity to { filteredInventory.find(item => item.value === invId)?.name || `ID: ${invId}` }
                                        </Button>
                                    </Box>
                                </Box>
                            ))}



                            {/* <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                            <Tooltip title="Add More Capacity" arrow>
                                <Button variant="outlined" sx={{ border: "2px dotted grey", width: "150px" }}><Typography sx={{ fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} onClick={handleAddCapacity}>Add Capacity</Typography></Button>
                            </Tooltip>
                            </Box> */}
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '8px',alignItems:"center" }}>
                                {imagePreviews?.map((image, index) => (
                                    <Box key={index} sx={{ width: '104px', height: '104px', border: '1px solid', borderColor: 'secondary.border', borderRadius: '8px', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative', cursor: 'pointer', backgroundColor: 'background.upload', overflow: 'hidden', '&:hover .overlay': { display: 'block', }, '&:hover .delete-button': { display: 'flex', }, }}>
                                        <img src={image} alt={`Uploaded ${index}`} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px', transition: 'opacity 0.3s', }} />
                                        <Box className="overlay" sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: '#00000080', display: 'none', borderRadius: '8px', }} />
                                        <Tooltip title="Delete" arrow>
                                            <IconButton className="delete-button" onClick={() => handleRemoveImage(index)} sx={{ position: 'absolute', top: "50%", left: "50%", display: 'none', transform: 'translate(-50%, -50%)', }}>
                                                <DeleteOutlineIcon sx={{ color: "white" }} />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                ))}
                                <Box
                                    sx={{ width: '104px', height: '104px', border: '1px solid', borderColor: 'secondary.border', borderRadius: '8px', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative', cursor: 'pointer', backgroundColor: 'background.upload', }}>
                                    <input type="file" accept="image/*" id="upload-input" style={{ position: 'absolute', width: '104px', height: '104px', opacity: 0, cursor: 'pointer', top: 0, left: 0 }} onChange={handleImageChange} name="images" />
                                    <label htmlFor="upload-input" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <AddIcon fontSize="large" />
                                        <Typography sx={{ fontSize: "14px", fontWeight: "400", lineHeight: "22px" }}>Upload</Typography>
                                    </label>
                                </Box>
                            {errors.images && <Typography style={{ color: "red" ,  fontSize: "12PX", fontWeight: "400", lineHeight: "22px"  }}>{errors.images}</Typography>}
                            {errors.image_urls && <Typography style={{ color: "red" ,  fontSize: "12PX", fontWeight: "400", lineHeight: "22px"  }}>{errors.image_urls}</Typography>}
                            </Box>
                        </Box>

                    </Box>
                    <Box sx={{ backgroundColor: "#EEEEEE", display: "flex", alignItems: "center", position: "absolute", bottom: 0, display: "flex", justifyContent: "flex-end", width: "100%" }}>
                        <Box sx={{ padding: "12px 24px", display: "flex", gap: "20px" }}>
                            <Button variant="outlined" sx={{ textTransform: "none", color: "black", backgroundColor: "white", height: "32px", width: "67px" }} onClick={handleClose}> cancel</Button>
                            <Button variant="contained" sx={{ textTransform: "none", height: "32px", width: "67px" }} onClick={() => edit ? handleUpdateProducts(productDetails.id) : handleSaveProducts()} > {edit ? loading?<CircularProgress size="25px" sx={{color:"white"}}/>:"Update" : loading?<CircularProgress size="25px" sx={{color:"white"}}/>:"Save"}</Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>
            {/* Date & Time Range Modal */}
            <Modal open={openDateRangeModal} onClose={() => { setOpenDateRangeModal(false); setModalError(''); }}>
                <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 680, bgcolor: 'background.paper', boxShadow: 24, p: 3, display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    <Typography sx={{ fontSize: '16px', fontWeight: 600 }}>Select date & time range</Typography>
                    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr auto 1fr', alignItems: 'center', gap: '16px' }}>
                        <DatePicker
                            selected={modalStartDateTime}
                            onChange={handleStartDateChange}
                            showTimeSelect
                            timeFormat="hh:mm aa"
                            timeIntervals={5}
                            dateFormat="MMM d, yyyy h:mm aa"
                            withPortal
                            portalId="date-time-portal"
                            minDate={new Date()} // Disable past dates (date-only; allow past time on today)
                            customInput={<DateTextField label="Start date & time" placeholder="Start date & time" />}
                        />
                        <Typography sx={{ fontSize: '14px', color: 'text.secondary' }}>to</Typography>
                        <DatePicker
                            selected={modalEndDateTime}
                            onChange={(d) => setModalEndDateTime(d)}
                            showTimeSelect
                            timeFormat="hh:mm aa"
                            timeIntervals={5}
                            dateFormat="MMM d, yyyy h:mm aa"
                            withPortal
                            portalId="date-time-portal"
                            minDate={new Date()} // Disable past dates (date-only); allow past time on today
                            maxDate={modalRepeatMode === 'month' && modalStartDateTime ? 
                                getLastDayOfMonth(modalStartDateTime) : 
                                modalRepeatMode === 'year' && modalStartDateTime ? 
                                getLastDayOfYear(modalStartDateTime) : 
                                null} // Limit end date based on repeat mode
                            customInput={<DateTextField 
                                label={`End date & time ${modalRepeatMode === 'year' ? '(Year-end)' : modalRepeatMode === 'month' ? '(Month-end)' : ''}`} 
                                placeholder="End date & time" 
                            />}
                        />
                    </Box>
                    {modalError && (
                        <Typography sx={{ color: 'red', fontSize: '12px' }}>{modalError}</Typography>
                    )}

                    <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>Repeat on days</Typography>
                    <Box sx={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
                        <Button variant={modalRepeatMode==='year'?'contained':'outlined'} size="small" onClick={() => handleRepeatModeChange('year')}>Year</Button>
                        <Button variant={modalRepeatMode==='month'?'contained':'outlined'} size="small" onClick={() => handleRepeatModeChange('month')}>Month</Button>
                        <Button variant={modalRepeatMode==='custom'?'contained':'outlined'} size="small" onClick={() => handleRepeatModeChange('custom')}>Custom</Button>
                        {modalRepeatMode === 'custom' && (
                            daysOfWeek.map((d) => {
                                const selected = Array.isArray(modalDaysOfWeek) && modalDaysOfWeek.includes(d.value);
                                return (
                                    <Button
                                        key={d.value}
                                        variant={selected ? 'contained' : 'outlined'}
                                        size="small"
                                        sx={{ minWidth: '48px', textTransform: 'none' }}
                                        onClick={() => {
                                            setModalRepeatMode('custom');
                                            const prev = Array.isArray(modalDaysOfWeek) ? modalDaysOfWeek : [];
                                            const next = selected ? prev.filter(v => v !== d.value) : [...prev, d.value];
                                            setModalDaysOfWeek(next);
                                        }}
                                    >{d.label}</Button>
                                );
                            })
                        )}
                    </Box>

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                        <Button variant="outlined" onClick={() => { setOpenDateRangeModal(false); setModalError(''); }}>Cancel</Button>
                        <Button variant="contained" onClick={() => {
                            if (!dateRangeContext) return;
                            const { inventoryId, capIndex } = dateRangeContext;
                            const start = modalStartDateTime;
                            const end = modalEndDateTime;
                            
                            // Clear any previous errors first
                            setModalError('');
                            
                            // Validation
                            if (!start || !end) { 
                                setModalError('Please select both start and end date & time'); 
                                return; 
                            }
                            
                            // Additional validation to ensure dates are valid Date objects
                            if (!(start instanceof Date) || !(end instanceof Date) || isNaN(start.getTime()) || isNaN(end.getTime())) {
                                setModalError('Please select valid start and end date & time');
                                return;
                            }
                            
                            if (modalRepeatMode === 'custom' && (!modalDaysOfWeek || modalDaysOfWeek.length === 0)) { 
                                setModalError('Please select at least one day'); 
                                return; 
                            }

                            // Check for zero-length window (same start and end)
                            if (start.getTime() === end.getTime()) {
                                setModalError('Start and end datetime cannot be the same');
                                return;
                            }


                             // Disallow same time-of-day even if dates differ (e.g., 11:00 AM to 11:00 AM on a later date)
                            const sameTimeOfDay =
                             start.getHours() === end.getHours() &&
                             start.getMinutes() === end.getMinutes() &&
                             start.getSeconds() === end.getSeconds();
                            if (sameTimeOfDay) {
                                setModalError('End time must differ from start time');
                                return;
                            }
                            
                            // Check for past calendar date (allow past times today)
                            const todayStart = new Date();
                            todayStart.setHours(0, 0, 0, 0);
                            const startDateOnly = new Date(start.getFullYear(), start.getMonth(), start.getDate());
                            const endDateOnly = new Date(end.getFullYear(), end.getMonth(), end.getDate());
                            if (startDateOnly < todayStart) {
                                setModalError('Start date cannot be in the past');
                                return;
                            }
                            if (endDateOnly < todayStart) {
                                setModalError('End date cannot be in the past');
                                return;
                            }

                            // Prevent selecting an end datetime that is earlier than the start date (different calendar day)
                            // Same-day end < start is handled as an overnight range below
                            if (end < start && end.toDateString() !== start.toDateString()) {
                                setModalError('End datetime cannot be earlier than start datetime');
                                return;
                            }
                            
                            setModalError('');

                            // Handle PM→AM midnight crossing
                            let finalEndDate = new Date(end);
                            const startMinutes = start.getHours() * 60 + start.getMinutes();
                            const endMinutes = end.getHours() * 60 + end.getMinutes();
                            const crossesMidnight = endMinutes <= startMinutes;
                            
                            // If end time is earlier than start time on the same day, increment end date by 1 day
                            if (crossesMidnight && start.toDateString() === end.toDateString()) {
                                finalEndDate = new Date(end);
                                finalEndDate.setDate(finalEndDate.getDate() + 1);
                            }

                            const startTime = format(start, 'HH:mm:ss');
                            const endTime = format(finalEndDate, 'HH:mm:ss');

                            handleCapacityChange(inventoryId, capIndex, { target: { name: 'ui_startDateTime', value: start.toISOString() } });
                            handleCapacityChange(inventoryId, capIndex, { target: { name: 'ui_endDateTime', value: finalEndDate.toISOString() } });
                            // Determine days based on repeat mode
                            const days = modalRepeatMode === 'year' ? [0,1,2,3,4,5,6] : modalDaysOfWeek;
                            handleCapacityChange(inventoryId, capIndex, { target: { name: 'ui_daysOfWeek', value: days } });
                            handleCapacityChange(inventoryId, capIndex, { target: { name: 'ui_repeatMode', value: modalRepeatMode } });
                            handleCapacityChange(inventoryId, capIndex, { target: { name: 'available_from', value: startTime } });
                            handleCapacityChange(inventoryId, capIndex, { target: { name: 'available_to', value: endTime } });
                            handleCapacityChange(inventoryId, capIndex, { target: { name: 'ui_crossesMidnight', value: crossesMidnight } });

                            setOpenDateRangeModal(false);
                        }}>Save</Button>
                    </Box>
                </Box>
            </Modal>
            {/* Bulk Scan & Add Modal - Fullscreen */}
            <Modal 
                open={bulkScanDialogOpen} 
                onClose={closeBulkScanDialog}
                sx={{ 
                    '& .MuiBackdrop-root': { 
                        backgroundColor: 'rgba(0, 0, 0, 0.8)' 
                    } 
                }}
            >
                <Box sx={{ 
                    position: 'fixed', 
                    top: 0, 
                    left: 0, 
                    right: 0, 
                    bottom: 0, 
                    width: '100vw', 
                    height: '100vh', 
                    backgroundColor: 'white', 
                    display: "flex", 
                    flexDirection: "column", 
                    overflow: 'hidden',
                    zIndex: 1300
                }}>
                    {/* Header */}
                    <Box sx={{ p: 2, borderBottom: "1px solid #e0e0e0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <Typography sx={{ fontSize: "20px", fontWeight: 700 }}>Bulk Scan & Add Products</Typography>
                        <IconButton onClick={closeBulkScanDialog} sx={{ color: 'text.secondary' }}>
                            <DeleteOutlineIcon />
                        </IconButton>
                    </Box>

                    {/* Main Content - Split Layout */}
                    <Box sx={{ display: "flex", flex: 1, overflow: 'hidden' }}>
                        {/* Left Side - Scanner Section */}
                        {scannerVisible ? (
                            <Box sx={{ width: '400px', borderRight: "1px solid #e0e0e0", p: 2, display: "flex", flexDirection: "column", gap: 2, overflow: 'auto', position: 'relative' }}>
                                {/* Close Scanner Button */}
                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
                                    <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>Scanner</Typography>
                                    <Tooltip title="Hide Scanner">
                                        <IconButton 
                                            size="small" 
                                            onClick={() => setScannerVisible(false)}
                                            sx={{ color: 'text.secondary' }}
                                        >
                                            <CloseIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                                
                                {/* Mode Selection Tabs */}
                                <Box sx={{ display: "flex", gap: 1 }}>
                                    <Button
                                        variant={bulkScanMode === "barcode" ? "contained" : "outlined"}
                                        startIcon={<QrCodeScannerIcon />}
                                        onClick={() => { setBulkScanMode("barcode"); setBulkScanError(""); }}
                                        sx={{ textTransform: "none", flex: 1 }}
                                        size="small"
                                    >
                                        Barcode
                                    </Button>
                                    <Button
                                        variant={bulkScanMode === "vision" ? "contained" : "outlined"}
                                        startIcon={<CameraAltIcon />}
                                        onClick={() => { setBulkScanMode("vision"); setBulkScanError(""); }}
                                        sx={{ textTransform: "none", flex: 1 }}
                                        size="small"
                                    >
                                        Vision AI
                                    </Button>
                                </Box>

                            {/* Scanner Section - Reduced Size */}
                            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                {bulkScanMode === "barcode" ? (
                                    <>
                                        <Typography sx={{ fontSize: "12px", color: "text.secondary" }}>
                                            Scan barcodes to add products
                                        </Typography>
                                        <Box sx={{ 
                                            width: '100%', 
                                            maxWidth: '350px', 
                                            height: '250px', 
                                            border: '1px solid #e0e0e0', 
                                            borderRadius: '8px',
                                            overflow: 'hidden',
                                            position: 'relative'
                                        }}>
                                            <BarcodeScanner 
                                                onDetected={handleBulkScanDetected} 
                                                onError={(msg) => setBulkScanError(msg)} 
                                                active={bulkScanDialogOpen && bulkScanMode === "barcode" && scannerVisible} 
                                            />
                                        </Box>
                                        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Enter code manually"
                                                value={bulkScannedCode}
                                                onChange={(e) => setBulkScannedCode(e.target.value)}
                                                onKeyPress={(e) => {
                                                    if (e.key === 'Enter' && bulkScannedCode.trim()) {
                                                        handleBulkScanDetected(bulkScannedCode);
                                                        setBulkScannedCode('');
                                                    }
                                                }}
                                                disabled={bulkScanLookupLoading}
                                            />
                                            <Button 
                                                variant="contained" 
                                                onClick={() => {
                                                    if (bulkScannedCode.trim()) {
                                                        handleBulkScanDetected(bulkScannedCode);
                                                        setBulkScannedCode('');
                                                    }
                                                }} 
                                                disabled={bulkScanLookupLoading || !bulkScannedCode.trim()} 
                                                sx={{ textTransform: "none", whiteSpace: "nowrap" }}
                                                size="small"
                                            >
                                                {bulkScanLookupLoading ? "..." : "Add"}
                                            </Button>
                                        </Box>
                                    </>
                                ) : (
                                    <>
                                        <Typography sx={{ fontSize: "12px", color: "text.secondary" }}>
                                            Point camera at product to identify
                                        </Typography>
                                        <Box sx={{ 
                                            width: '100%', 
                                            maxWidth: '350px', 
                                            height: '250px', 
                                            border: '1px solid #e0e0e0', 
                                            borderRadius: '8px',
                                            overflow: 'hidden',
                                            position: 'relative',
                                            '& > *': {
                                                width: '100%',
                                                height: '100%'
                                            }
                                        }}>
                                            <VisionProductScanner 
                                                active={bulkScanDialogOpen && bulkScanMode === "vision" && scannerVisible}
                                                onDetected={handleBulkVisionDetected}
                                                onError={handleBulkVisionError}
                                                onLoading={setBulkVisionLoading}
                                                onCaptureRef={visionCaptureRef}
                                                hideInternalButton={true}
                                            />
                                        </Box>
                                        {/* External Capture Button */}
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() => {
                                                if (visionCaptureRef.current) {
                                                    visionCaptureRef.current();
                                                }
                                            }}
                                            disabled={bulkVisionLoading}
                                            fullWidth
                                            sx={{
                                                textTransform: "none",
                                                fontSize: "14px",
                                                fontWeight: 600,
                                                mt: 1
                                            }}
                                        >
                                            {bulkVisionLoading ? "Identifying..." : "Capture & Identify"}
                                        </Button>
                                        {bulkVisionLoading && (
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1, justifyContent: "center" }}>
                                                <CircularProgress size={16} />
                                                <Typography sx={{ fontSize: "12px", color: "text.secondary" }}>
                                                    Analyzing product...
                                                </Typography>
                                            </Box>
                                        )}
                                    </>
                                )}
                                
                                {bulkScanError && (
                                    <Typography color="error" variant="body2" sx={{ fontSize: "12px" }}>
                                        {bulkScanError}
                                    </Typography>
                                )}
                            </Box>
                        </Box>
                        ) : (
                            /* Show Scanner Button when hidden */
                            <Box sx={{ width: '40px', borderRight: "1px solid #e0e0e0", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: '#f5f5f5' }}>
                                <Tooltip title="Show Scanner" placement="right">
                                    <IconButton 
                                        onClick={() => setScannerVisible(true)}
                                        sx={{ color: 'text.secondary' }}
                                    >
                                        <ChevronRightIcon />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        )}

                        {/* Right Side - Products Table */}
                        <Box sx={{ flex: 1, display: "flex", flexDirection: "column", overflow: 'hidden', p: 2 }}>
                            <Typography sx={{ fontSize: "18px", fontWeight: 600, mb: 2 }}>
                                Scanned Products ({scannedProducts.length})
                            </Typography>
                            {scannedProducts.length > 0 ? (
                                <TableContainer component={Paper} sx={{ flex: 1, overflow: 'auto' }}>
                                    <Table stickyHeader size="medium">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{ fontWeight: 600, minWidth: 80 }}>Image</TableCell>
                                                <TableCell sx={{ fontWeight: 600, minWidth: 150 }}>Name</TableCell>
                                                <TableCell sx={{ fontWeight: 600, minWidth: 120 }}>SKU/Barcode</TableCell>
                                                <TableCell sx={{ fontWeight: 600, minWidth: 120 }}>Category</TableCell>
                                                <TableCell sx={{ fontWeight: 600, minWidth: 100 }}>Criteria</TableCell>
                                                <TableCell sx={{ fontWeight: 600, minWidth: 150 }}>Inventory</TableCell>
                                                <TableCell sx={{ fontWeight: 600, minWidth: 200 }}>Description</TableCell>
                                                <TableCell sx={{ fontWeight: 600, minWidth: 100 }}>Price</TableCell>
                                                <TableCell sx={{ fontWeight: 600, minWidth: 100 }}>Capacity</TableCell>
                                                <TableCell sx={{ fontWeight: 600, minWidth: 200 }}>Actions</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {scannedProducts.map((product) => {
                                                const productImage = product.image_urls?.[0] || product.images?.[0] || "";
                                                const inventoryNames = (product.inventory || []).map(invId => {
                                                    const inv = filteredInventory.find(i => i.value === invId);
                                                    return inv?.name || `ID: ${invId}`;
                                                }).join(", ") || "Not selected";
                                                
                                                return (
                                                    <TableRow key={product.id} hover>
                                                        <TableCell>
                                                            {productImage ? (
                                                                <Box
                                                                    component="img"
                                                                    src={productImage}
                                                                    alt={product.item_name}
                                                                    sx={{
                                                                        width: 60,
                                                                        height: 60,
                                                                        objectFit: 'cover',
                                                                        borderRadius: '4px',
                                                                        border: '1px solid #e0e0e0'
                                                                    }}
                                                                />
                                                            ) : (
                                                                <Box
                                                                    sx={{
                                                                        width: 60,
                                                                        height: 60,
                                                                        backgroundColor: '#f5f5f5',
                                                                        borderRadius: '4px',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        border: '1px solid #e0e0e0'
                                                                    }}
                                                                >
                                                                    <Typography sx={{ fontSize: '10px', color: 'text.secondary' }}>No Image</Typography>
                                                                </Box>
                                                            )}
                                                        </TableCell>
                                                        <TableCell>{product.item_name || "N/A"}</TableCell>
                                                        <TableCell>
                                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                                <Typography sx={{ fontSize: '13px' }}>
                                                                    {product.sku_code || "N/A"}
                                                                </Typography>
                                                                {product.sku_code && (
                                                                    <Tooltip title="View/Edit Barcode">
                                                                        <IconButton 
                                                                            size="small" 
                                                                            onClick={() => {
                                                                                setEditingProductId(product.id);
                                                                                setEditingProduct({ ...product });
                                                                                setProductEditDialogOpen(true);
                                                                            }}
                                                                            sx={{ p: 0.5 }}
                                                                        >
                                                                            <QrCodeScannerIcon fontSize="small" />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                )}
                                                            </Box>
                                                        </TableCell>
                                                        <TableCell>{product.item_category || "N/A"}</TableCell>
                                                        <TableCell>
                                                            <Chip 
                                                                label={product.item_criteria || "Not set"} 
                                                                size="small" 
                                                                color={product.item_criteria ? "primary" : "default"}
                                                                sx={{ fontSize: '11px' }}
                                                            />
                                                        </TableCell>
                                                        <TableCell>
                                                            <Typography sx={{ fontSize: '12px', maxWidth: 150, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                                {inventoryNames}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell sx={{ maxWidth: 300 }}>
                                                            <Typography sx={{ 
                                                                overflow: 'hidden', 
                                                                textOverflow: 'ellipsis', 
                                                                display: '-webkit-box',
                                                                WebkitLineClamp: 2,
                                                                WebkitBoxOrient: 'vertical',
                                                                fontSize: '13px'
                                                            }}>
                                                                {product.item_description || "N/A"}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            {(() => {
                                                                const inventoryId = product.inventory?.[0] || selectedHub;
                                                                const capacityDetails = product.capacitydetails || {};
                                                                let capacity = null;
                                                                if (Array.isArray(capacityDetails)) {
                                                                    capacity = capacityDetails[0];
                                                                } else if (capacityDetails && typeof capacityDetails === 'object') {
                                                                    capacity = capacityDetails[inventoryId]?.[0] || capacityDetails[Object.keys(capacityDetails)[0]]?.[0];
                                                                }
                                                                return capacity?.item_price || "N/A";
                                                            })()}
                                                        </TableCell>
                                                        <TableCell>
                                                            {(() => {
                                                                const inventoryId = product.inventory?.[0] || selectedHub;
                                                                const capacityDetails = product.capacitydetails || {};
                                                                let capacity = null;
                                                                if (Array.isArray(capacityDetails)) {
                                                                    capacity = capacityDetails[0];
                                                                } else if (capacityDetails && typeof capacityDetails === 'object') {
                                                                    capacity = capacityDetails[inventoryId]?.[0] || capacityDetails[Object.keys(capacityDetails)[0]]?.[0];
                                                                }
                                                                return capacity?.item_capacity || 
                                                                       `${capacity?.capacityValue || ''} ${capacity?.unit || ''}`.trim() || "N/A";
                                                            })()}
                                                        </TableCell>
                                                        <TableCell>
                                                            <Box sx={{ display: "flex", gap: 0.5, flexWrap: 'wrap' }}>
                                                                <Tooltip title="Edit Product">
                                                                    <IconButton 
                                                                        size="small" 
                                                                        onClick={() => handleEditScannedProduct(product.id)}
                                                                        color="primary"
                                                                    >
                                                                        <EditIcon fontSize="small" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                <Tooltip title="Edit Capacity Details">
                                                                    <IconButton 
                                                                        size="small" 
                                                                        onClick={() => handleEditScannedProductCapacity(product.id)}
                                                                        color="secondary"
                                                                    >
                                                                        <SettingsIcon fontSize="small" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                <Tooltip title="Remove">
                                                                    <IconButton 
                                                                        size="small" 
                                                                        onClick={() => handleRemoveScannedProduct(product.id)}
                                                                        color="error"
                                                                    >
                                                                        <DeleteOutlineIcon fontSize="small" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </Box>
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            ) : (
                                <Box sx={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <Typography sx={{ color: "text.secondary", textAlign: "center" }}>
                                        No products scanned yet. Use the scanner to add products.
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                    </Box>

                    {/* Error Display */}
                    {bulkErrors?.length > 0 && (
                        <Box sx={{ maxHeight: 150, overflowY: "auto", p: 1, border: "1px solid", borderColor: "error.main", borderRadius: "6px", backgroundColor: "#ffebee", mx: 2 }}>
                            <Typography sx={{ fontWeight: 600, mb: 1, color: "error.main" }}>Failed rows</Typography>
                            {bulkErrors.map((err, idx) => (
                                <Typography key={idx} sx={{ fontSize: "12px", color: "error.main" }}>
                                    Row {err?.row}: {err?.message}
                                </Typography>
                            ))}
                        </Box>
                    )}

                    {/* Action Buttons */}
                    <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2, p: 2, borderTop: "1px solid #e0e0e0", backgroundColor: '#fafafa' }}>
                        <Button 
                            variant="outlined" 
                            onClick={() => {
                                dispatch(clearScannedProducts());
                                localStorage.removeItem('scannedProducts');
                            }}
                            disabled={scannedProducts.length === 0}
                            sx={{ textTransform: "none" }}
                        >
                            Clear All
                        </Button>
                        <Box sx={{ display: "flex", gap: 1 }}>
                            <Button 
                                variant="outlined" 
                                onClick={closeBulkScanDialog}
                                sx={{ textTransform: "none" }}
                            >
                                Cancel
                            </Button>
                            <LoadingButton
                                variant="contained"
                                loading={bulkUploading}
                                onClick={handleBulkSaveScannedProducts}
                                disabled={scannedProducts.length === 0}
                                sx={{ textTransform: "none" }}
                            >
                                Save & Upload ({scannedProducts.length})
                            </LoadingButton>
                        </Box>
                    </Box>
                </Box>
            </Modal>

            {/* Capacity Details Edit Dialog */}
            <Modal open={capacityEditDialogOpen} onClose={() => setCapacityEditDialogOpen(false)}>
                <Box sx={{ 
                    position: 'absolute', 
                    top: '50%', 
                    left: '50%', 
                    transform: 'translate(-50%, -50%)', 
                    width: '90%', 
                    maxWidth: '600px', 
                    backgroundColor: 'white', 
                    p: 3, 
                    borderRadius: "8px",
                    maxHeight: '90vh',
                    overflow: 'auto'
                }}>
                    <Typography sx={{ fontSize: "18px", fontWeight: 700, mb: 2 }}>
                        Edit Capacity Details
                    </Typography>
                    {editingCapacity && (
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                            <Box sx={{ display: "flex", gap: 2 }}>
                                <Box sx={{ flex: 1 }}>
                                    <Typography sx={{ fontSize: "14px", mb: 1 }}>Capacity Value</Typography>
                                    <InputBase
                                        value={editingCapacity.capacityValue || ""}
                                        onChange={(e) => handleCapacityFieldChange('capacityValue', e.target.value)}
                                        sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px" }}
                                        placeholder="e.g., 250"
                                    />
                                </Box>
                                <Box sx={{ flex: 1 }}>
                                    <Typography sx={{ fontSize: "14px", mb: 1 }}>Unit</Typography>
                                    <Autocomplete
                                        options={capacity || []}
                                        value={capacity.find(opt => opt.value === editingCapacity.unit) || null}
                                        onChange={(_e, value) => handleCapacityFieldChange('unit', value?.value || "")}
                                        getOptionLabel={(option) => option?.name || ""}
                                        isOptionEqualToValue={(opt, val) => opt?.value === val?.value}
                                        renderInput={(params) => <TextField {...params} size="small" placeholder="Select unit" />}
                                    />
                                </Box>
                            </Box>
                            <Box sx={{ display: "flex", gap: 2 }}>
                                <Box sx={{ flex: 1 }}>
                                    <Typography sx={{ fontSize: "14px", mb: 1 }}>Price</Typography>
                                    <InputBase
                                        value={editingCapacity.item_price || ""}
                                        onChange={(e) => {
                                            const price = e.target.value;
                                            handleCapacityFieldChange('item_price', price);
                                            // Auto-calculate selling price if extraPercentage exists
                                            if (editingCapacity.extraPercentage) {
                                                const priceNum = parseFloat(price) || 0;
                                                const extra = parseFloat(editingCapacity.extraPercentage) || 0;
                                                handleCapacityFieldChange('item_selling_price', (priceNum + (priceNum * extra) / 100).toFixed(2));
                                            }
                                        }}
                                        sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px" }}
                                        placeholder="Enter price"
                                    />
                                </Box>
                                <Box sx={{ flex: 1 }}>
                                    <Typography sx={{ fontSize: "14px", mb: 1 }}>Tax %</Typography>
                                    <InputBase
                                        value={editingCapacity.item_tax || ""}
                                        onChange={(e) => handleCapacityFieldChange('item_tax', e.target.value)}
                                        sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px" }}
                                        placeholder="Enter tax %"
                                    />
                                </Box>
                            </Box>
                            <Box sx={{ display: "flex", gap: 2 }}>
                                <Box sx={{ flex: 1 }}>
                                    <Typography sx={{ fontSize: "14px", mb: 1 }}>Margin %</Typography>
                                    <InputBase
                                        value={editingCapacity.extraPercentage || ""}
                                        onChange={(e) => {
                                            const extra = e.target.value;
                                            handleCapacityFieldChange('extraPercentage', extra);
                                            // Auto-calculate selling price if price exists
                                            if (editingCapacity.item_price) {
                                                const price = parseFloat(editingCapacity.item_price) || 0;
                                                const extraNum = parseFloat(extra) || 0;
                                                handleCapacityFieldChange('item_selling_price', (price + (price * extraNum) / 100).toFixed(2));
                                            }
                                        }}
                                        sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px" }}
                                        placeholder="Enter margin %"
                                    />
                                </Box>
                                <Box sx={{ flex: 1 }}>
                                    <Typography sx={{ fontSize: "14px", mb: 1 }}>Selling Price</Typography>
                                    <InputBase
                                        value={editingCapacity.item_selling_price || ""}
                                        onChange={(e) => handleCapacityFieldChange('item_selling_price', e.target.value)}
                                        sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px" }}
                                        placeholder="Auto-calculated"
                                    />
                                </Box>
                            </Box>
                            <Box sx={{ display: "flex", gap: 2 }}>
                                <Box sx={{ flex: 1 }}>
                                    <Typography sx={{ fontSize: "14px", mb: 1 }}>Special Offer %</Typography>
                                    <InputBase
                                        value={editingCapacity.item_special_offer || ""}
                                        onChange={(e) => {
                                            const offer = e.target.value;
                                            handleCapacityFieldChange('item_special_offer', offer);
                                            // Auto-calculate offer price
                                            if (editingCapacity.item_selling_price) {
                                                const sellingPrice = parseFloat(editingCapacity.item_selling_price) || 0;
                                                const offerNum = parseFloat(offer) || 0;
                                                handleCapacityFieldChange('item_offers_price', (sellingPrice - ((offerNum / 100) * sellingPrice)).toFixed(2));
                                            }
                                        }}
                                        sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px" }}
                                        placeholder="Enter offer %"
                                        endAdornment={<InputAdornment position="end">% off</InputAdornment>}
                                    />
                                </Box>
                                <Box sx={{ flex: 1 }}>
                                    <Typography sx={{ fontSize: "14px", mb: 1 }}>Offer Price</Typography>
                                    <InputBase
                                        value={editingCapacity.item_offers_price || ""}
                                        onChange={(e) => handleCapacityFieldChange('item_offers_price', e.target.value)}
                                        sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px" }}
                                        placeholder="Auto-calculated"
                                    />
                                </Box>
                            </Box>
                            <Box>
                                <Typography sx={{ fontSize: "14px", mb: 1 }}>Availability</Typography>
                                <Autocomplete
                                    options={availability || []}
                                    value={availability.find(opt => opt.value === editingCapacity.item_available) || null}
                                    onChange={(_e, value) => handleCapacityFieldChange('item_available', value?.value ?? true)}
                                    getOptionLabel={(option) => option?.name || ""}
                                    isOptionEqualToValue={(opt, val) => opt?.value === val?.value}
                                    renderInput={(params) => <TextField {...params} size="small" placeholder="Select availability" />}
                                />
                            </Box>
                            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 2 }}>
                                <Button 
                                    variant="outlined" 
                                    onClick={() => {
                                        setCapacityEditDialogOpen(false);
                                        setEditingProductId(null);
                                        setEditingCapacity(null);
                                    }}
                                    sx={{ textTransform: "none" }}
                                >
                                    Cancel
                                </Button>
                                <Button 
                                    variant="contained" 
                                    onClick={handleSaveCapacityDetails}
                                    sx={{ textTransform: "none" }}
                                >
                                    Save
                                </Button>
                            </Box>
                        </Box>
                    )}
                </Box>
            </Modal>

            {/* Product Details Edit Dialog (Criteria & Inventory) */}
            <Modal open={productEditDialogOpen} onClose={() => setProductEditDialogOpen(false)}>
                <Box sx={{ 
                    position: 'absolute', 
                    top: '50%', 
                    left: '50%', 
                    transform: 'translate(-50%, -50%)', 
                    width: '90%', 
                    maxWidth: '700px', 
                    backgroundColor: 'white', 
                    p: 3, 
                    borderRadius: "8px",
                    maxHeight: '90vh',
                    overflow: 'auto'
                }}>
                    <Typography sx={{ fontSize: "18px", fontWeight: 700, mb: 2 }}>
                        Edit Product Details
                    </Typography>
                    {editingProduct && (
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                            {/* Product Image Preview */}
                            {editingProduct.image_urls?.[0] && (
                                <Box>
                                    <Typography sx={{ fontSize: "14px", mb: 1 }}>Product Image</Typography>
                                    <Box
                                        component="img"
                                        src={editingProduct.image_urls[0]}
                                        alt={editingProduct.item_name}
                                        sx={{
                                            width: 150,
                                            height: 150,
                                            objectFit: 'cover',
                                            borderRadius: '8px',
                                            border: '1px solid #e0e0e0'
                                        }}
                                    />
                                </Box>
                            )}

                            {/* Product Name */}
                            <Box>
                                <Typography sx={{ fontSize: "14px", mb: 1 }}>Product Name</Typography>
                                <InputBase
                                    value={editingProduct.item_name || ""}
                                    onChange={(e) => setEditingProduct(prev => ({ ...prev, item_name: e.target.value }))}
                                    sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px" }}
                                    placeholder="Product name"
                                />
                            </Box>

                            {/* SKU Code / Barcode */}
                            <Box>
                                <Typography sx={{ fontSize: "14px", mb: 1 }}>SKU Code / Barcode</Typography>
                                <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                                    <InputBase
                                        value={editingProduct.sku_code || ""}
                                        onChange={(e) => setEditingProduct(prev => ({ ...prev, sku_code: e.target.value }))}
                                        sx={{ backgroundColor: "white", flex: 1, height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px" }}
                                        placeholder="Enter SKU code or barcode"
                                    />
                                    {editingProduct.sku_code && (
                                        <Tooltip title="Barcode">
                                            <Box sx={{ display: "flex", alignItems: "center", p: 1, border: "1px solid #e0e0e0", borderRadius: "4px" }}>
                                                <QrCodeScannerIcon sx={{ fontSize: "20px", color: "text.secondary" }} />
                                            </Box>
                                        </Tooltip>
                                    )}
                                </Box>
                            </Box>

                            {/* Category */}
                            <Box>
                                <Typography sx={{ fontSize: "14px", mb: 1 }}>Category</Typography>
                                <Autocomplete
                                    options={category || []}
                                    value={category.find(opt => opt.value === editingProduct.item_category) || null}
                                    onChange={(_e, value) => setEditingProduct(prev => ({ ...prev, item_category: value?.value || "" }))}
                                    getOptionLabel={(option) => option?.name || ""}
                                    isOptionEqualToValue={(opt, val) => opt?.value === val?.value}
                                    renderInput={(params) => <TextField {...params} size="small" placeholder="Select category" />}
                                />
                            </Box>

                            {/* Sub Category */}
                            <Box>
                                <Typography sx={{ fontSize: "14px", mb: 1 }}>Sub Category</Typography>
                                <Autocomplete
                                    options={subCategory || []}
                                    value={subCategory.find(opt => opt.value === editingProduct.item_sub_category) || null}
                                    onChange={(_e, value) => setEditingProduct(prev => ({ ...prev, item_sub_category: value?.value || "" }))}
                                    getOptionLabel={(option) => option?.name || ""}
                                    isOptionEqualToValue={(opt, val) => opt?.value === val?.value}
                                    renderInput={(params) => <TextField {...params} size="small" placeholder="Select sub category" />}
                                    disabled={editingProduct.item_category === "Addon"}
                                />
                            </Box>

                            {/* Criteria */}
                            <Box>
                                <Typography sx={{ fontSize: "14px", mb: 1 }}>Criteria</Typography>
                                <Autocomplete
                                    options={criteria || []}
                                    value={criteria.find(opt => opt.value === editingProduct.item_criteria || opt.name === editingProduct.item_criteria) || null}
                                    onChange={(_e, value) => setEditingProduct(prev => ({ ...prev, item_criteria: value?.value || value?.name || "" }))}
                                    getOptionLabel={(option) => option?.name || ""}
                                    isOptionEqualToValue={(opt, val) => opt?.value === val?.value || opt?.name === val?.name}
                                    renderInput={(params) => <TextField {...params} size="small" placeholder="Select criteria" />}
                                />
                            </Box>

                            {/* Inventory Selection - Default to selectedHub */}
                            <Box>
                                <Typography sx={{ fontSize: "14px", mb: 1 }}>Inventory List</Typography>
                                <Autocomplete
                                    multiple
                                    options={filteredInventory || []}
                                    value={(filteredInventory || []).filter(opt => {
                                        const currentInventory = editingProduct.inventory || [];
                                        // If no inventory set, default to selectedHub
                                        if (currentInventory.length === 0 && selectedHub) {
                                            return opt.value === selectedHub;
                                        }
                                        return currentInventory.includes(opt.value);
                                    })}
                                    onChange={(_e, value) => {
                                        const selectedInventories = value.map(v => v.value);
                                        // Ensure selectedHub is always included if available
                                        const finalInventories = selectedInventories.length > 0 
                                            ? selectedInventories 
                                            : (selectedHub ? [selectedHub] : []);
                                        
                                        // Update capacitydetails structure to match new inventory
                                        const updatedCapacityDetails = {};
                                        finalInventories.forEach(invId => {
                                            // Preserve existing capacity for this inventory, or create new one
                                            const existingCapacity = editingProduct.capacitydetails?.[invId]?.[0] 
                                                || editingProduct.capacitydetails?.[Object.keys(editingProduct.capacitydetails || {})[0]]?.[0]
                                                || {
                                                    item_price: "",
                                                    item_available: true,
                                                    item_capacity: "",
                                                    item_quantity: "",
                                                    item_tax: "",
                                                    item_selling_price: "",
                                                    item_offers_price: 0.00,
                                                    extraPercentage: "",
                                                    capacityValue: "",
                                                    unit: "",
                                                    item_special_offer: ""
                                                };
                                            updatedCapacityDetails[invId] = [existingCapacity];
                                        });
                                        
                                        setEditingProduct(prev => ({ 
                                            ...prev, 
                                            inventory: finalInventories,
                                            capacitydetails: updatedCapacityDetails
                                        }));
                                    }}
                                    getOptionLabel={(option) => option?.name || ""}
                                    isOptionEqualToValue={(opt, val) => opt?.value === val?.value}
                                    getOptionDisabled={(opt) => !!opt?.disabled}
                                    renderInput={(params) => (
                                        <TextField {...params} size="small" placeholder="Select Inventory" />
                                    )}
                                    renderTags={(value, getTagProps) =>
                                        value.map((option, index) => (
                                            <Chip
                                                label={option.name}
                                                size="small"
                                                {...getTagProps({ index })}
                                                key={option.value}
                                            />
                                        ))
                                    }
                                    disableCloseOnSelect
                                />
                                {selectedHub && (
                                    <Typography sx={{ fontSize: "12px", color: "text.secondary", mt: 0.5 }}>
                                        Default: {filteredInventory.find(i => i.value === selectedHub)?.name || `Hub ${selectedHub}`}
                                    </Typography>
                                )}
                            </Box>

                            {/* Description */}
                            <Box>
                                <Typography sx={{ fontSize: "14px", mb: 1 }}>Description</Typography>
                                <InputBase
                                    value={editingProduct.item_description || ""}
                                    onChange={(e) => setEditingProduct(prev => ({ ...prev, item_description: e.target.value }))}
                                    sx={{ backgroundColor: "white", width: "100%", minHeight: "60px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px" }}
                                    placeholder="Product description"
                                    multiline
                                    rows={3}
                                />
                            </Box>

                            {/* Action Buttons */}
                            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 2 }}>
                                <Button 
                                    variant="outlined" 
                                    onClick={() => {
                                        setProductEditDialogOpen(false);
                                        setEditingProductId(null);
                                        setEditingProduct(null);
                                    }}
                                    sx={{ textTransform: "none" }}
                                >
                                    Cancel
                                </Button>
                                <Button 
                                    variant="contained" 
                                    onClick={handleSaveProductDetails}
                                    sx={{ textTransform: "none" }}
                                >
                                    Save
                                </Button>
                            </Box>
                        </Box>
                    )}
                </Box>
            </Modal>
            <OrderModal/>
            <OrderModalDelivery/>
        </Box>
    )
}